import { useState, useEffect } from "react";

// ── THEME ──────────────────────────────────────────────────────────────────────
const C = {
  bg:"#f0f4f8", card:"#ffffff", card2:"#f8fafc",
  accent:"#2563eb", accentDim:"rgba(37,99,235,0.10)", accentLight:"#eff6ff",
  text:"#1e293b", muted:"#64748b", faint:"#94a3b8",
  border:"#e2e8f0", borderStrong:"#cbd5e1",
  red:"#ef4444", redDim:"rgba(239,68,68,0.10)", redLight:"#fef2f2",
  green:"#16a34a", greenDim:"rgba(22,163,74,0.10)", greenLight:"#f0fdf4",
  yellow:"#d97706", yellowDim:"rgba(217,119,6,0.10)", yellowLight:"#fffbeb",
  purple:"#7c3aed", purpleDim:"rgba(124,58,237,0.10)", purpleLight:"#f5f3ff",
  orange:"#ea580c", orangeDim:"rgba(234,88,12,0.12)", orangeLight:"#fff7ed",
};

const shadow = "0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)";
const shadowMd = "0 4px 12px rgba(0,0,0,0.10)";

// ── DATA ───────────────────────────────────────────────────────────────────────
const INIT_COACHES = [];
const INIT_PAYMENTS = [];
const INIT_REQUESTS = [];

const INIT_LOCATIONS = [];
const INIT_SESSIONS = [];
const INIT_PLAYERS = [];

// ── HELPERS ────────────────────────────────────────────────────────────────────
const lvlCfg = l => l==="Начинающий"?{bg:C.accentDim,tx:C.accent}:l==="Средний"?{bg:C.yellowDim,tx:C.yellow}:{bg:C.purpleDim,tx:C.purple};

const Chip = ({label,small}) => {const s=lvlCfg(label);return <span style={{background:s.bg,color:s.tx,padding:small?"2px 8px":"3px 11px",borderRadius:20,fontSize:small?10:11,fontWeight:700,letterSpacing:"0.03em",textTransform:"uppercase",whiteSpace:"nowrap"}}>{label}</span>;};

const Tag = ({children,color=C.accent,bg}) => <span style={{background:bg||C.accentDim,color,padding:"2px 9px",borderRadius:20,fontSize:11,fontWeight:700}}>{children}</span>;

const Btn = ({children,onClick,variant="primary",small,full,disabled,style:sx={}}) => {
  const styles = {
    primary:{bg:C.accent,color:"#fff",border:"none"},
    ghost:{bg:"transparent",color:C.accent,border:`1.5px solid ${C.accent}`},
    danger:{bg:C.redDim,color:C.red,border:"none"},
    success:{bg:C.greenDim,color:C.green,border:"none"},
    neutral:{bg:C.bg,color:C.muted,border:`1px solid ${C.border}`},
    warning:{bg:C.yellowDim,color:C.yellow,border:"none"},
  };
  const v=styles[variant]||styles.primary;
  return <button onClick={onClick} disabled={disabled} style={{background:v.bg,color:disabled?C.faint:v.color,border:v.border,borderRadius:10,padding:small?"7px 14px":"11px 18px",fontWeight:700,fontSize:small?12:14,cursor:disabled?"not-allowed":"pointer",width:full?"100%":undefined,opacity:disabled?0.6:1,...sx}}>{children}</button>;
};

const Input = ({label,value,onChange,placeholder,type="text",unit,note}) => (
  <div style={{marginBottom:14}}>
    {label&&<div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:5}}>{label}</div>}
    <div style={{position:"relative"}}>
      <input value={value} onChange={onChange} type={type} placeholder={placeholder} style={{width:"100%",border:`1.5px solid ${C.border}`,borderRadius:10,padding:"10px 14px",fontSize:14,color:C.text,background:"#fff",boxSizing:"border-box",outline:"none",paddingRight:unit?40:14}} onFocus={e=>e.target.style.borderColor=C.accent} onBlur={e=>e.target.style.borderColor=C.border}/>
      {unit&&<span style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",fontSize:13,color:C.muted}}>{unit}</span>}
    </div>
    {note&&<div style={{fontSize:11,color:C.faint,marginTop:4}}>{note}</div>}
  </div>
);

const Toggle = ({label,checked,onChange,note}) => (
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:C.card2,border:`1px solid ${C.border}`,borderRadius:12,padding:"12px 14px",marginBottom:10}}>
    <div>
      <div style={{fontSize:14,fontWeight:600,color:C.text}}>{label}</div>
      {note&&<div style={{fontSize:11,color:C.faint,marginTop:2}}>{note}</div>}
    </div>
    <div onClick={onChange} style={{width:44,height:24,borderRadius:12,background:checked?C.accent:C.borderStrong,cursor:"pointer",position:"relative",transition:"background 0.2s",flexShrink:0}}>
      <div style={{position:"absolute",top:2,left:checked?20:2,width:20,height:20,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.2)"}}/>
    </div>
  </div>
);

const Card = ({children,style:sx={}}) => <div style={{background:C.card,borderRadius:16,border:`1px solid ${C.border}`,boxShadow:shadow,padding:16,marginBottom:12,...sx}}>{children}</div>;

const Section = ({title,children}) => <div style={{marginBottom:20}}><div style={{fontSize:11,fontWeight:700,color:C.faint,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:10}}>{title}</div>{children}</div>;

const BottomSheet = ({title,onClose,children}) => (
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",display:"flex",alignItems:"flex-end",zIndex:300}} onClick={onClose}>
    <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:"20px 20px 0 0",padding:"0 0 32px",width:"100%",maxHeight:"88vh",overflowY:"auto",boxShadow:"0 -4px 24px rgba(0,0,0,0.15)"}}>
      <div style={{padding:"20px 20px 16px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",position:"sticky",top:0,background:"#fff",zIndex:1}}>
        <div style={{fontWeight:800,fontSize:17,color:C.text}}>{title}</div>
        <button onClick={onClose} style={{background:C.bg,border:"none",borderRadius:"50%",width:32,height:32,cursor:"pointer",fontSize:16,color:C.muted}}>✕</button>
      </div>
      <div style={{padding:"16px 20px"}}>{children}</div>
    </div>
  </div>
);

// ── ADD SESSION MODAL ──────────────────────────────────────────────────────────
// ── MINI CALENDAR ──────────────────────────────────────────────────────────────
const RU_MONTHS = ["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"];
const RU_DAYS   = ["Пн","Вт","Ср","Чт","Пт","Сб","Вс"];
const RU_DAY_SHORT = ["","Пн","Вт","Ср","Чт","Пт","Сб","Вс"];

// Форматирует время "02:20:00" → "02:20"
const formatTime = (t) => {
  if (!t) return "";
  return t.slice(0, 5);
};

// Возвращает ISO дату в локальном времени (без UTC-смещения)
const localISO = (d) => {
  const pad = n => String(n).padStart(2,'0');
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
};
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const day = RU_DAY_SHORT[d.getDay()===0?7:d.getDay()];
  return `${day}, ${d.getDate()} ${RU_MONTHS[d.getMonth()].slice(0,3).toLowerCase()} ${d.getFullYear()}`;
};

function MiniCalendar({value, onChange}) {
  const today = new Date();
  today.setHours(0,0,0,0);
  const [view, setView] = useState(value ? new Date(value) : today);
  const year = view.getFullYear(), month = view.getMonth();

  const firstDay = new Date(year, month, 1);
  // Monday-based week: getDay() 0=Sun→6, 1=Mon→0 ...
  const startOffset = (firstDay.getDay()+6)%7;
  const daysInMonth = new Date(year, month+1, 0).getDate();
  const cells = [];
  for(let i=0;i<startOffset;i++) cells.push(null);
  for(let d=1;d<=daysInMonth;d++) cells.push(d);

  const selDate = value ? new Date(value) : null;
  const isSel = d => selDate && selDate.getFullYear()===year && selDate.getMonth()===month && selDate.getDate()===d;
  const isToday = d => today.getFullYear()===year && today.getMonth()===month && today.getDate()===d;

  const select = d => {
    const dt = new Date(year,month,d);
    const dayName = RU_DAY_SHORT[dt.getDay()===0?7:dt.getDay()];
    const label = `${dayName}, ${d} ${RU_MONTHS[month].slice(0,3).toLowerCase()} ${year}`;
    onChange(dt.toISOString().slice(0,10), label);
  };

  const prev = () => setView(new Date(year, month-1, 1));
  const next = () => setView(new Date(year, month+1, 1));

  return (
    <div style={{background:"#fff",border:`1.5px solid ${C.border}`,borderRadius:14,padding:"14px 12px",marginBottom:14}}>
      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <button onClick={prev} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:C.muted,padding:"4px 8px"}}>‹</button>
        <span style={{fontWeight:700,fontSize:14,color:C.text}}>{RU_MONTHS[month]} {year}</span>
        <button onClick={next} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:C.muted,padding:"4px 8px"}}>›</button>
      </div>
      {/* Day names */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",marginBottom:6}}>
        {RU_DAYS.map(d=><div key={d} style={{textAlign:"center",fontSize:11,fontWeight:600,color:C.faint,padding:"2px 0"}}>{d}</div>)}
      </div>
      {/* Cells */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:2}}>
        {cells.map((d,i)=>(
          <div key={i} onClick={d?()=>select(d):undefined}
            style={{height:34,display:"flex",alignItems:"center",justifyContent:"center",borderRadius:8,cursor:d?"pointer":"default",
              background:d&&isSel(d)?C.accent:d&&isToday(d)?C.accentLight:"transparent",
              color:d&&isSel(d)?"#fff":d&&isToday(d)?C.accent:d?C.text:"transparent",
              fontWeight:d&&(isSel(d)||isToday(d))?700:400,fontSize:13,
            }}>
            {d||""}
          </div>
        ))}
      </div>
    </div>
  );
}

// ── TIME PICKER ────────────────────────────────────────────────────────────────
function TimePicker({value, onChange}) {
  const [h, setH] = useState(value ? Number(value.split(":")[0]) : 9);
  const [m, setM] = useState(value ? Number(value.split(":")[1]) : 0);

  const pad = n => String(n).padStart(2,"0");
  const update = (nh, nm) => { onChange(`${pad(nh)}:${pad(nm)}`); };

  const stepH = d => { const nh=(h+d+24)%24; setH(nh); update(nh,m); };
  const stepM = d => { const nm=(m+d+60)%60; setM(nm); update(h,nm); };

  const Stepper = ({val, onUp, onDown, label}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
      <button onClick={onUp}   style={{background:C.accentLight,border:"none",borderRadius:8,width:36,height:32,cursor:"pointer",fontSize:16,color:C.accent,fontWeight:700}}>▲</button>
      <div style={{fontWeight:800,fontSize:28,color:C.text,width:52,textAlign:"center",lineHeight:1}}>{String(val).padStart(2,"0")}</div>
      <button onClick={onDown} style={{background:C.accentLight,border:"none",borderRadius:8,width:36,height:32,cursor:"pointer",fontSize:16,color:C.accent,fontWeight:700}}>▼</button>
      <div style={{fontSize:11,color:C.faint}}>{label}</div>
    </div>
  );

  return (
    <div style={{background:"#fff",border:`1.5px solid ${C.border}`,borderRadius:14,padding:"16px",marginBottom:14,display:"flex",alignItems:"center",justifyContent:"center",gap:12}}>
      <Stepper val={h} onUp={()=>stepH(1)} onDown={()=>stepH(-1)} label="часы"/>
      <div style={{fontSize:28,fontWeight:800,color:C.muted,paddingBottom:20}}>:</div>
      <Stepper val={m} onUp={()=>stepM(5)} onDown={()=>stepM(-5)} label="минуты"/>
    </div>
  );
}

function SessionFormModal({onClose, onSave, locations, session, levels, formPlayers, token, API}) {
  const isEdit = !!session;
  const [dateIso, setDateIso] = useState(isEdit ? (session.date||"").slice(0,10) : "");
  const [dateLabel,setDateLabel] = useState(isEdit ? formatDate(session.date) : "");
  const [time,    setTime]     = useState(isEdit ? session.time    : "09:00");
  const [level,   setLevel]    = useState(isEdit ? session.level   : (levels?.[0]||"Начинающий"));
  const [duration,setDuration] = useState(isEdit ? session.duration: 60);
  const [locId,   setLocId]    = useState(isEdit ? (session.location_id||session.locId||(locations[0]?.id||null)) : (locations[0]?.id||null));
  const [maxP,    setMaxP]     = useState(isEdit ? (parseInt(session.max_players||session.max)||4) : 4);
  const [price,   setPrice]    = useState(isEdit ? String(session.price||0): "");
  const [freeSlot,setFreeSlot]         = useState(isEdit ? (session.free_slot||session.free||false) : false);
  const [repeat,  setRepeat]           = useState(isEdit ? (session.repeat_weekly||session.repeat||false) : false);
  const [repeatUntilIso,  setRepeatUntilIso]   = useState("");
  const [repeatUntilLabel,setRepeatUntilLabel] = useState(isEdit ? (session.repeatUntil||"") : "");
  const [showFormManual,setShowFormManual] = useState(false);
  const [formAdded, setFormAdded]      = useState(new Set());
  const [confirmCancel, setConfirmCancel] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState(null);

  const [saveToast, setSaveToast] = useState(null);
  const handleSave = async () => {
    setSaveError(null);

    // Проверка: нельзя создать тренировку в прошлом
    const chosenDate = dateIso || session?.date;
    if (!isEdit && chosenDate && time) {
      const chosenDateTime = new Date(`${chosenDate.slice(0,10)}T${time}:00`);
      if (chosenDateTime < new Date()) {
        setSaveError("Нельзя создать тренировку в прошлом");
        return;
      }
    }

    setSaving(true);
    const body = {
      date: dateIso || session?.date,
      time,
      level,
      duration,
      location_id: locations.length > 0 ? locId : null,
      max_players: maxP,
      price: Number(price),
      free_slot: freeSlot,
      repeat_weekly: repeat,
      repeat_until: repeatUntilIso || null,
    };
    try {
      const url = isEdit ? `${API}/sessions/${session.id}` : `${API}/sessions`;
      const method = isEdit ? 'PATCH' : 'POST';
      const r = await fetch(url, {
        method,
        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || 'Ошибка сервера');
      // После создания тренировки — добавляем участников вручную
      if (!isEdit && formAdded.size > 0) {
        const sessionId = data.id || (data.sessions && data.sessions[0]?.id);
        if (sessionId) {
          await Promise.all([...formAdded].map(playerId =>
            fetch(API+'/bookings/manual', {
              method: 'POST',
              headers: {'Authorization':'Bearer '+token, 'Content-Type':'application/json'},
              body: JSON.stringify({session_id: sessionId, player_id: playerId})
            }).catch(()=>{})
          ));
        }
        setSaveToast("📲 Уведомлено " + formAdded.size + " участников: " + (dateLabel||"новая тренировка") + " · " + time);
      }
      onSave && onSave(data);
    } catch(e) {
      setSaveError(e.message);
    } finally {
      setSaving(false);
    }
  };

  const levelList = levels && levels.length > 0 ? levels : ["Начинающий","Средний","Продвинутый"];

  return (
    <BottomSheet title={isEdit ? "Редактировать тренировку" : "Новая тренировка"} onClose={onClose}>
      {isEdit && (
        <div style={{background:C.accentLight,borderRadius:12,padding:"10px 14px",marginBottom:16,fontSize:13,color:C.accent,fontWeight:500}}>
          ✏️ Редактирование тренировки
        </div>
      )}

      {/* Date */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:5}}>Дата</div>
        <input type="date" value={dateIso} min={new Date().toISOString().slice(0,10)}
          onChange={e=>{
            const iso=e.target.value;
            setDateIso(iso);
            if(iso){const d=new Date(iso);setDateLabel(formatDate(iso));}
          }}
          style={{width:"100%",border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 14px",fontSize:15,color:C.text,background:"#fff",outline:"none",boxSizing:"border-box"}}
        />
      </div>

      {/* Time */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:8}}>Время начала</div>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center"}}>
            <input type="number" min="0" max="23" placeholder="09"
              onChange={e=>{
                const v=e.target.value;
                const m=time.split(":")[1]||"00";
                setTime(`${String(v).padStart(2,"0")}:${m}`);
              }}
              style={{width:"100%",textAlign:"center",border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 8px",fontSize:26,fontWeight:500,color:C.text,background:"#fff",outline:"none",boxSizing:"border-box",MozAppearance:"textfield"}}
            />
            <div style={{fontSize:11,color:C.faint,marginTop:4}}>часы</div>
          </div>
          <div style={{fontSize:28,fontWeight:500,color:C.muted,paddingBottom:18}}>:</div>
          <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center"}}>
            <input type="number" min="0" max="59" placeholder="00"
              onChange={e=>{
                const v=e.target.value;
                const h=time.split(":")[0]||"09";
                setTime(`${h}:${String(v).padStart(2,"0")}`);
              }}
              style={{width:"100%",textAlign:"center",border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 8px",fontSize:26,fontWeight:500,color:C.text,background:"#fff",outline:"none",boxSizing:"border-box",MozAppearance:"textfield"}}
            />
            <div style={{fontSize:11,color:C.faint,marginTop:4}}>минуты</div>
          </div>
        </div>
      </div>

      {/* Duration */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:5}}>Длительность</div>
        <div style={{display:"flex",alignItems:"center",border:`1.5px solid ${C.border}`,borderRadius:12,background:"#fff",overflow:"hidden"}}>
          <button onClick={()=>setDuration(d=>Math.max(10,d-10))} style={{width:56,height:52,border:"none",borderRight:`1.5px solid ${C.border}`,background:duration<=10?C.bg:C.accentLight,fontSize:22,color:duration<=10?C.faint:C.accent,cursor:duration<=10?"not-allowed":"pointer",fontWeight:700,flexShrink:0}}>−</button>
          <div style={{flex:1,textAlign:"center"}}>
            <span style={{fontWeight:800,fontSize:22,color:C.text}}>{duration}</span>
            <span style={{fontSize:13,color:C.muted,marginLeft:5}}>мин</span>
          </div>
          <button onClick={()=>setDuration(d=>Math.min(240,d+10))} style={{width:56,height:52,border:"none",borderLeft:`1.5px solid ${C.border}`,background:duration>=240?C.bg:C.accentLight,fontSize:22,color:duration>=240?C.faint:C.accent,cursor:duration>=240?"not-allowed":"pointer",fontWeight:700,flexShrink:0}}>+</button>
        </div>
      </div>

      {/* Level */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:5}}>Уровень</div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {levelList.map(l=>{const s=lvlCfg(l);return <button key={l} onClick={()=>setLevel(l)} style={{flex:"1 0 auto",padding:"8px 10px",borderRadius:10,border:`1.5px solid ${level===l?s.tx:C.border}`,background:level===l?s.bg:"#fff",color:level===l?s.tx:C.muted,fontSize:12,fontWeight:700,cursor:"pointer"}}>{l}</button>;})}
        </div>
      </div>

      {/* Location */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:5}}>Локация</div>
        <select value={locId} onChange={e=>setLocId(Number(e.target.value))} style={{width:"100%",border:`1.5px solid ${C.border}`,borderRadius:10,padding:"10px 14px",fontSize:14,color:C.text,background:"#fff",boxSizing:"border-box"}}>
          {locations.map(l=><option key={l.id} value={l.id}>{l.name}</option>)}
        </select>
      </div>

      {/* Max players stepper */}
      <div style={{marginBottom:10}}>
        <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:5}}>Максимум участников</div>
        <div style={{display:"flex",alignItems:"center",border:`1.5px solid ${C.border}`,borderRadius:12,background:"#fff",overflow:"hidden"}}>
          <button onClick={()=>setMaxP(v=>Math.max(1,v-1))} style={{width:52,height:48,border:"none",borderRight:`1.5px solid ${C.border}`,background:"#fff",fontSize:22,color:maxP<=1?C.faint:C.accent,cursor:maxP<=1?"not-allowed":"pointer",fontWeight:300,flexShrink:0}}>−</button>
          <div style={{flex:1,textAlign:"center"}}>
            <span style={{fontWeight:800,fontSize:20,color:C.text}}>{maxP}</span>
            <span style={{fontSize:13,color:C.muted,marginLeft:6}}>участников</span>
          </div>
          <button onClick={()=>setMaxP(v=>v+1)} style={{width:52,height:48,border:"none",borderLeft:`1.5px solid ${C.border}`,background:"#fff",fontSize:22,color:C.accent,cursor:"pointer",fontWeight:300,flexShrink:0}}>+</button>
        </div>
      </div>

      {/* Price — text input */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:5}}>Стоимость</div>
        <div style={{position:"relative"}}>
          <input value={price} onChange={e=>setPrice(e.target.value)} type="number" placeholder="1500"
            style={{width:"100%",border:`1.5px solid ${C.border}`,borderRadius:10,padding:"10px 36px 10px 14px",fontSize:14,color:C.text,background:"#fff",boxSizing:"border-box",outline:"none"}}
            onFocus={e=>e.target.style.borderColor=C.accent} onBlur={e=>e.target.style.borderColor=C.border}/>
          <span style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",fontSize:13,color:C.muted}}>₽</span>
        </div>
        <div style={{fontSize:11,color:C.faint,marginTop:4}}>Оставьте 0 для бесплатной тренировки</div>
      </div>

      {/* Add players manually from form */}
      {formPlayers && formPlayers.length>0 && (
        <button onClick={()=>setShowFormManual(true)} style={{width:"100%",background:C.purpleDim,border:`1.5px solid ${C.purple}44`,borderRadius:12,padding:"11px",cursor:"pointer",fontSize:13,fontWeight:700,color:C.purple,marginBottom:14,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
          👤 Добавить участников вручную {formAdded.size>0&&<span style={{background:C.purple,color:"#fff",borderRadius:20,padding:"1px 8px",fontSize:11}}>{formAdded.size}</span>}
        </button>
      )}

      <Toggle label="Свободная запись" checked={freeSlot} onChange={()=>setFreeSlot(!freeSlot)} note="Участники смогут самостоятельно записываться на этот слот"/>

      {/* Repeat weekly + end date */}
      <Toggle label="Повторять еженедельно" checked={repeat} onChange={()=>{setRepeat(!repeat);if(repeat){setRepeatUntilIso("");setRepeatUntilLabel("");}}} note="Тренировка будет создаваться каждую неделю в то же время"/>

      {repeat && (
        <div style={{background:C.yellowLight,border:`1px solid ${C.yellow}33`,borderRadius:14,padding:"14px",marginBottom:14,marginTop:-4}}>
          <div style={{fontSize:12,fontWeight:600,color:C.yellow,marginBottom:10}}>↻ Повторять до:</div>
          {repeatUntilIso ? (
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"#fff",borderRadius:10,padding:"10px 14px",border:`1px solid ${C.yellow}44`}}>
              <span style={{fontSize:14,fontWeight:700,color:C.text}}>📅 {formatDate(repeatUntilIso)}</span>
              <button onClick={()=>{setRepeatUntilIso("");setRepeatUntilLabel("");}} style={{background:"none",border:"none",color:C.faint,fontSize:16,cursor:"pointer",padding:"0 4px"}}>✕</button>
            </div>
          ) : (
            <div>
              <div style={{fontSize:12,color:C.muted,marginBottom:8}}>Выберите дату последней тренировки:</div>
              <input type="date" value={repeatUntilIso} min={dateIso||new Date().toISOString().slice(0,10)}
                onChange={e=>{setRepeatUntilIso(e.target.value);setRepeatUntilLabel(e.target.value);}}
                style={{width:"100%",border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 14px",fontSize:15,color:C.text,background:"#fff",outline:"none",boxSizing:"border-box"}}
              />
            </div>
          )}
          {!repeatUntilLabel && (
            <div style={{fontSize:11,color:C.yellow,marginTop:6}}>Если не указать — тренировка будет повторяться бесконечно</div>
          )}
        </div>
      )}
      <div style={{height:12}}/>
      {saveError && (
        <div style={{background:'#fee2e2',border:'1.5px solid #fca5a5',borderRadius:10,padding:'10px 14px',marginBottom:10,fontSize:13,color:'#dc2626',fontWeight:500}}>
          ⚠️ {saveError}
        </div>
      )}
      <button onClick={handleSave} disabled={saving} style={{
        width:"100%", background:saving?'#93c5fd':C.accent, color:"#fff", border:"none",
        borderRadius:12, padding:"16px", fontWeight:800, fontSize:16,
        cursor:saving?"not-allowed":"pointer", marginBottom: isEdit ? 10 : 0,
      }}>{saving ? "Сохранение..." : isEdit ? "Сохранить изменения" : "Создать тренировку"}</button>

      {isEdit && !confirmCancel && (
        <button onClick={()=>setConfirmCancel(true)} style={{
          width:"100%", background:C.redLight, color:C.red, border:`1.5px solid ${C.red}33`,
          borderRadius:12, padding:"12px", fontWeight:700, fontSize:14,
          cursor:"pointer",
        }}>Отменить тренировку</button>
      )}

      {isEdit && confirmCancel && (
        <div style={{background:C.redLight,border:`1.5px solid ${C.red}44`,borderRadius:14,padding:"16px",marginTop:4}}>
          <div style={{fontWeight:700,fontSize:15,color:C.red,marginBottom:6,textAlign:"center"}}>⚠️ Отменить тренировку?</div>
          <div style={{fontSize:13,color:C.muted,textAlign:"center",marginBottom:14,lineHeight:1.5}}>
            {session.booked>0
              ? "На тренировку записано " + session.booked + " участников — они получат уведомление об отмене."
              : "Тренировка будет удалена."}
          </div>

          {session.repeat ? (
            <>
              <div style={{display:"flex",gap:8,marginBottom:8}}>
                <Btn full variant="danger" onClick={()=>{onSave&&onSave({...session,cancelled:true});setConfirmCancel(false);}}>
                  Только эту
                </Btn>
                <Btn full variant="danger" onClick={()=>{onSave&&onSave({...session,cancelled:true,cancelChain:true});setConfirmCancel(false);}}>
                  🔁 Всю цепочку
                </Btn>
              </div>
              <Btn full variant="neutral" onClick={()=>setConfirmCancel(false)}>Назад</Btn>
            </>
          ) : (
            <div style={{display:"flex",gap:8}}>
              <Btn full variant="neutral" onClick={()=>setConfirmCancel(false)}>Назад</Btn>
              <Btn full variant="danger" onClick={()=>{onSave&&onSave({...session,cancelled:true});setConfirmCancel(false);}}>
                {session.booked>0 ? "Отменить и уведомить" : "Да, отменить"}
              </Btn>
            </div>
          )}
        </div>
      )}

      {showFormManual && <ManualAddModal
        session={{date:dateLabel||"Новая тренировка",time,level,price:Number(price),max:maxP,booked:0}}
        allPlayers={formPlayers}
        onClose={()=>setShowFormManual(false)}
        notifyOnSave={false}
        onSaved={(n,_)=>setFormAdded(prev=>{const s=new Set(prev);formPlayers.filter(p=>p.level===level&&!p.blocked).slice(0,n).forEach(p=>s.add(p.id));return s;})}
      />}
      {saveToast&&<Toast message={saveToast} onDone={()=>{setSaveToast(null);}}/>}
    </BottomSheet>
  );
}

// ── PAYMENT MODAL ──────────────────────────────────────────────────────────────
function PaymentModal({session,players,onClose}) {
  const [amounts,setAmounts] = useState(Object.fromEntries(players.map(p=>[p.id,session.price])));
  const [paid,setPaid] = useState({});

  return (
    <BottomSheet title="Учёт оплаты" onClose={onClose}>
      <div style={{background:C.accentLight,borderRadius:12,padding:"10px 14px",marginBottom:16}}>
        <div style={{fontSize:13,color:C.accent,fontWeight:600}}>{session.date} · {session.time} · {session.level}</div>
        <div style={{fontSize:12,color:C.muted,marginTop:2}}>Базовая стоимость: {session.price}₽</div>
      </div>

      {players.slice(0,session.booked).map(p=>(
        <div key={p.id} style={{background:paid[p.id]?C.greenLight:C.card2,border:`1px solid ${paid[p.id]?C.green+"33":C.border}`,borderRadius:14,padding:"12px 14px",marginBottom:10}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
            <div>
              <div style={{fontWeight:700,fontSize:14,color:C.text}}>{p.name}</div>
              <div style={{fontSize:12,color:C.muted}}><Chip label={p.level} small/></div>
            </div>
            <Btn small variant={paid[p.id]?"success":"ghost"} onClick={()=>setPaid(v=>({...v,[p.id]:!v[p.id]}))}>
              {paid[p.id]?"✓ Оплачено":"Отметить"}
            </Btn>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:12,color:C.muted,whiteSpace:"nowrap"}}>Сумма:</span>
            <input value={amounts[p.id]} onChange={e=>setAmounts(v=>({...v,[p.id]:e.target.value}))} type="number" style={{flex:1,border:`1.5px solid ${C.border}`,borderRadius:8,padding:"6px 10px",fontSize:14,color:C.text,background:"#fff"}}/>
            <span style={{fontSize:13,color:C.muted}}>₽</span>
          </div>
        </div>
      ))}
      <div style={{height:12}}/>
      <Btn full onClick={onClose}>Сохранить</Btn>
    </BottomSheet>
  );
}

// ── LOCATION MANAGER ───────────────────────────────────────────────────────────
function LocationManager({locations, setLocations, token, API}) {
  const [editing, setEditing] = useState(null);
  const [draft, setDraft] = useState({});
  const [adding, setAdding] = useState(false);
  const [newDraft, setNewDraft] = useState({name:"", address:""});
  const [saving, setSaving] = useState(false);

  const save = id => {
    setLocations(ls=>ls.map(l=>l.id===id?{...l,...draft}:l));
    setEditing(null);
  };

  const addLocation = async () => {
    if (!newDraft.name.trim()) return;
    setSaving(true);
    try {
      const r = await fetch(API+'/locations', {
        method: 'POST',
        headers: {'Authorization':'Bearer '+token, 'Content-Type':'application/json'},
        body: JSON.stringify({name: newDraft.name, address: newDraft.address})
      });
      const data = await r.json();
      if (r.ok) {
        setLocations(ls=>[...ls, data]);
        setNewDraft({name:"", address:""});
        setAdding(false);
      }
    } catch(e) {}
    setSaving(false);
  };

  return (
    <Section title="Мои локации">
      {locations.map(l=>(
        <Card key={l.id}>
          {editing===l.id?(
            <>
              <Input label="Название" value={draft.name||l.name} onChange={e=>setDraft(d=>({...d,name:e.target.value}))} placeholder="Название корта"/>
              <Input label="Адрес" value={draft.address||l.address} onChange={e=>setDraft(d=>({...d,address:e.target.value}))} placeholder="Адрес"/>
              <div style={{display:"flex",gap:8}}>
                <Btn full small variant="neutral" onClick={()=>setEditing(null)}>Отмена</Btn>
                <Btn full small onClick={()=>save(l.id)}>Сохранить</Btn>
              </div>
            </>
          ):(
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <div style={{fontWeight:700,fontSize:14,color:C.text}}>📍 {l.name}</div>
                <div style={{fontSize:12,color:C.muted,marginTop:3}}>{l.address}</div>
              </div>
              <Btn small variant="ghost" onClick={()=>{setEditing(l.id);setDraft({name:l.name,address:l.address});}}>Изменить</Btn>
            </div>
          )}
        </Card>
      ))}
      {adding ? (
        <Card>
          <Input label="Название" value={newDraft.name} onChange={e=>setNewDraft(d=>({...d,name:e.target.value}))} placeholder="Например: Корт №1, Лужники"/>
          <Input label="Адрес" value={newDraft.address} onChange={e=>setNewDraft(d=>({...d,address:e.target.value}))} placeholder="Адрес"/>
          <div style={{display:"flex",gap:8,marginTop:4}}>
            <Btn full small variant="neutral" onClick={()=>{setAdding(false);setNewDraft({name:"",address:""});}}>Отмена</Btn>
            <Btn full small onClick={addLocation} disabled={saving}>{saving?"Сохранение...":"Добавить"}</Btn>
          </div>
        </Card>
      ) : (
        <Btn full variant="ghost" small onClick={()=>setAdding(true)}>+ Добавить локацию</Btn>
      )}
    </Section>
  );
}

// ── PAYMENTS OVERVIEW ──────────────────────────────────────────────────────────
function PaymentsOverview({players, token, API}) {
  const [balances, setBalances] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [showSum, setShowSum]   = useState(false);

  useEffect(()=>{
    if(!token) return;
    fetch(API+'/payments/balances', {headers:{'Authorization':'Bearer '+token}})
      .then(r=>r.json())
      .then(data=>{ if(Array.isArray(data)) setBalances(data); setLoading(false); })
      .catch(()=>setLoading(false));
  },[token]);

  if(loading) return <div style={{textAlign:"center",padding:40,color:C.muted}}>Загрузка...</div>;

  return (
    <Section title="Баланс участников">
      {/* Переключатель */}
      {balances.length>0&&(
        <div style={{display:"flex",justifyContent:"flex-end",marginBottom:14}}>
          <button onClick={()=>setShowSum(!showSum)} style={{
            display:"flex",alignItems:"center",gap:6,background:"#fff",
            border:`1.5px solid ${C.border}`,borderRadius:20,padding:"6px 14px",
            fontSize:12,fontWeight:600,color:C.accent,cursor:"pointer"
          }}>
            {showSum ? "💰 Показать баланс" : "📊 Показать сумму"}
          </button>
        </div>
      )}

      {balances.length===0&&(
        <div style={{textAlign:"center",padding:"32px 16px",color:C.muted,fontSize:14}}>Нет участников</div>
      )}

      {balances.map(p=>{
        const charged = parseInt(p.total_charged||0);
        const paid    = parseInt(p.total_paid||0);
        const balance = paid - charged; // положительный = переплата, отрицательный = долг
        const sessions = parseInt(p.session_count||0);

        const balanceColor = balance > 0 ? C.green : balance < 0 ? C.red : C.muted;
        const balanceLabel = balance > 0 ? "переплата" : balance < 0 ? "долг" : "всё оплачено";
        const balanceStr   = balance > 0 ? `+${balance.toLocaleString()}₽` : balance < 0 ? `${balance.toLocaleString()}₽` : "0₽";

        return (
          <Card key={p.player_id} style={{marginBottom:10}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <div style={{fontWeight:700,fontSize:14,color:C.text}}>{p.name}</div>
                <div style={{fontSize:12,color:C.muted,marginTop:2}}>
                  {p.username?`@${p.username} · `:""}
                  {sessions} {sessions===1?"тренировка":sessions<5?"тренировки":"тренировок"}
                </div>
              </div>
              <div style={{textAlign:"right"}}>
                {showSum ? (
                  <>
                    <div style={{fontWeight:800,fontSize:20,color:C.text}}>{paid.toLocaleString()}₽</div>
                    <div style={{fontSize:10,color:C.faint,marginTop:2}}>оплачено всего</div>
                  </>
                ) : (
                  <>
                    <div style={{fontWeight:800,fontSize:20,color:balanceColor}}>{balanceStr}</div>
                    <div style={{fontSize:10,color:balanceColor,marginTop:2}}>{balanceLabel}</div>
                  </>
                )}
              </div>
            </div>
          </Card>
        );
      })}
    </Section>
  );
}

// ── INVITE MODAL ───────────────────────────────────────────────────────────────
function InviteModal({onClose, token, API}) {
  const [copied, setCopied] = useState(false);
  const [inviteCode, setInviteCode] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    fetch(API+'/coach/invite', {headers:{'Authorization':'Bearer '+token}})
      .then(r=>r.json())
      .then(data=>{ setInviteCode(data.invite_code); setLoading(false); })
      .catch(()=>setLoading(false));
  },[]);

  const link = inviteCode ? `https://t.me/mycoachspace_bot?start=${inviteCode}` : '';

  const copy = () => {
    if(link) {
      navigator.clipboard?.writeText(link).catch(()=>{});
      setCopied(true);
      setTimeout(()=>setCopied(false), 2500);
    }
  };

  return (
    <BottomSheet title="Пригласить участника" onClose={onClose}>
      <div style={{fontSize:14,color:C.muted,marginBottom:16,lineHeight:1.6}}>
        Отправьте эту ссылку участнику. После перехода он автоматически привяжется к вам и будет видеть только ваши тренировки.
      </div>
      {loading ? (
        <div style={{textAlign:"center",padding:"20px",color:C.muted}}>Загрузка...</div>
      ) : (
        <>
          <div style={{background:C.bg,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 14px",fontSize:13,color:C.text,fontFamily:"monospace",wordBreak:"break-all",marginBottom:14}}>
            {link}
          </div>
          <Btn full onClick={copy} variant={copied?"success":"primary"}>
            {copied ? "✓ Ссылка скопирована!" : "Скопировать ссылку"}
          </Btn>
        </>
      )}
    </BottomSheet>
  );
}

// ── COACH VIEWS ────────────────────────────────────────────────────────────────
// ── SESSION DETAIL SHEET (shared: home + sessions list) ───────────────────────
function SessionDetailSheet({s, locations, players, onEdit, onPay, onManual, onMessage, onClose}) {
  const locName = id => locations.find(l=>l.id===id)?.name||"";
  const cl = lvlColors[s.level] || {bg:C.accentLight,border:C.accent+"44",text:C.accent};
  return (
    <BottomSheet title="Тренировка" onClose={onClose}>
      <div style={{background:cl.bg,border:`1px solid ${cl.border}`,borderRadius:14,padding:"14px 16px",marginBottom:16}}>
        <div style={{fontWeight:800,fontSize:22,color:cl.text}}>{formatTime(s.time)} <span style={{fontSize:14,fontWeight:400}}>· {s.duration} мин</span></div>
        <div style={{fontSize:13,color:cl.text,opacity:0.8,marginTop:4}}>{formatDate(s.date)}</div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
        {[{l:"Локация",v:"📍 "+locName(s.locId)},{l:"Стоимость",v:s.price?s.price+"₽":"Бесплатно"},{l:"Участники",v:s.booked+" из "+s.max},{l:"Уровень",v:s.level}].map(x=>(
          <div key={x.l} style={{background:C.bg,borderRadius:12,padding:"10px 12px"}}>
            <div style={{fontSize:11,color:C.faint,marginBottom:3}}>{x.l}</div>
            <div style={{fontWeight:700,fontSize:13,color:C.text}}>{x.v}</div>
          </div>
        ))}
      </div>
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:16}}>
        {s.free&&<Tag bg={C.greenDim} color={C.green}>Свободная запись</Tag>}
        {s.repeat&&<Tag bg={C.yellowDim} color={C.yellow}>↻ {s.repeatUntil?"до "+s.repeatUntil:"Еженедельно"}</Tag>}
      </div>
      <div style={{display:"flex",gap:8,marginBottom:8}}>
        <Btn full variant="ghost" onClick={onEdit}>✏️ Изменить</Btn>
        <Btn full variant="success" onClick={onPay}>💳 Оплата</Btn>
      </div>
      <div style={{display:"flex",gap:8,marginBottom:8}}>
        <Btn full style={{background:C.purpleDim,color:C.purple,border:"none"}} onClick={onManual}>👤 Добавить участников</Btn>
        <Btn full variant="warning" onClick={onMessage}>✉️ Написать участникам</Btn>
      </div>
    </BottomSheet>
  );
}

// ── MESSAGE COMPOSER ───────────────────────────────────────────────────────────
function MessageComposer({session, onClose, token, API}) {
  const [text, setText] = useState("");
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const handleSend = async () => {
    if(!text.trim()) return;
    setSending(true);
    try {
      await fetch(API+'/sessions/'+session.id+'/notify', {
        method: 'POST',
        headers: {'Authorization':'Bearer '+token, 'Content-Type':'application/json'},
        body: JSON.stringify({message: text.trim()})
      });
      setSent(true);
    } catch(e) { setSent(true); }
    setSending(false);
  };
  return (
    <BottomSheet title="Написать участникам" onClose={onClose}>
      <div style={{background:C.accentLight,borderRadius:12,padding:"10px 14px",marginBottom:14,fontSize:13,color:C.accent}}>
        📅 {session.date} · {session.time} · {session.level}
        <div style={{fontSize:12,color:C.muted,marginTop:2}}>{session.booked} участников получат сообщение</div>
      </div>
      {sent ? (
        <div style={{textAlign:"center",padding:"30px 0"}}>
          <div style={{fontSize:40,marginBottom:12}}>✅</div>
          <div style={{fontWeight:700,fontSize:16,color:C.text,marginBottom:6}}>Сообщение отправлено!</div>
          <div style={{fontSize:13,color:C.muted,marginBottom:20}}>Все {session.booked} участников получили ваше сообщение в Telegram</div>
          <Btn full onClick={onClose}>Закрыть</Btn>
        </div>
      ) : (
        <>
          <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:6}}>Текст сообщения</div>
          <textarea value={text} onChange={e=>setText(e.target.value)}
            placeholder={"Например: «Тренировка переносится на другую локацию — встречаемся у корта №2»"}
            style={{width:"100%",border:`1.5px solid ${text?C.accent:C.border}`,borderRadius:12,padding:"12px 14px",fontSize:14,color:C.text,background:"#fff",boxSizing:"border-box",minHeight:110,resize:"none",fontFamily:"inherit",outline:"none"}}
            onFocus={e=>e.target.style.borderColor=C.accent} onBlur={e=>e.target.style.borderColor=text?C.accent:C.border}
          />
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:6,marginBottom:16}}>
            <span style={{fontSize:12,color:C.faint}}>{text.length} символов</span>
            {text.trim() && <span style={{fontSize:12,color:C.accent}}>✓ Готово к отправке</span>}
          </div>
          <Btn full onClick={handleSend} disabled={!text.trim()||sending}>{sending ? 'Отправка...' : `Отправить ${session.booked||''} участникам`}</Btn>
        </>
      )}
    </BottomSheet>
  );
}

function CoachHome({sessions, locations, onAdd, players, setPlayers, onEditSession, onPaySession, onManualSession, token, API}) {
  const locName  = id => locations.find(l=>l.id===id)?.name||"";
  const [showInvite,   setShowInvite]   = useState(false);
  const [showPayments, setShowPayments] = useState(false);
  const [activeSession,setActiveSession]= useState(null);
  const [msgSession,   setMsgSession]   = useState(null);

  // Считаем реальную статистику
  const today = new Date(); today.setHours(0,0,0,0);
  const todayISO = localISO(today);
  const weekEnd = new Date(today); weekEnd.setDate(today.getDate()+7);
  const weekEndISO = localISO(weekEnd);

  const upcomingSessions = sessions.filter(s => {
    const iso = (s.date||"").slice(0,10);
    return iso >= todayISO;
  });
  const todayCount = upcomingSessions.filter(s=>(s.date||"").slice(0,10)===todayISO).length;
  const weekCount  = upcomingSessions.filter(s=>(s.date||"").slice(0,10)<=weekEndISO).length;
  const activePlayersCount = players.filter(p=>!p.blocked).length;

  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:22}}>
        {[{l:"Сегодня",v:todayCount,s:"тренировки"},{l:"Неделя",v:weekCount,s:"тренировок"},{l:"Участники",v:activePlayersCount,s:"активных"}].map(x=>(
          <Card key={x.l} sx={{padding:"14px 10px",textAlign:"center"}}>
            <div style={{fontSize:26,fontWeight:800,color:C.accent}}>{x.v}</div>
            <div style={{fontSize:11,color:C.muted,marginTop:2}}>{x.l}</div>
            <div style={{fontSize:10,color:C.faint}}>{x.s}</div>
          </Card>
        ))}
      </div>

      <Section title="Действия">
        {/* Action buttons */}
        <button onClick={onAdd} style={{width:"100%",background:C.accent,border:"none",borderRadius:14,padding:"14px 10px",cursor:"pointer",boxShadow:shadow,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:6,marginTop:4,marginBottom:10}}>
          <span style={{fontSize:22}}>➕</span>
          <span style={{fontWeight:700,fontSize:13,color:"#fff"}}>Создать тренировку</span>
          <span style={{fontSize:11,color:"rgba(255,255,255,0.75)"}}>Новая тренировка</span>
        </button>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <button onClick={()=>setShowInvite(true)} style={{background:"#fff",border:`1.5px solid ${C.border}`,borderRadius:14,padding:"14px 10px",cursor:"pointer",boxShadow:shadow,display:"flex",flexDirection:"column",alignItems:"center",gap:6}}>
            <span style={{fontSize:22}}>🔗</span>
            <span style={{fontWeight:700,fontSize:13,color:C.text}}>Пригласить</span>
            <span style={{fontSize:11,color:C.muted}}>Ссылка для участника</span>
          </button>
          <button onClick={()=>setShowPayments(true)} style={{background:"#fff",border:`1.5px solid ${C.border}`,borderRadius:14,padding:"14px 10px",cursor:"pointer",boxShadow:shadow,display:"flex",flexDirection:"column",alignItems:"center",gap:6}}>
            <span style={{fontSize:22}}>💳</span>
            <span style={{fontWeight:700,fontSize:13,color:C.text}}>Оплата</span>
            <span style={{fontSize:11,color:C.muted}}>Баланс участников</span>
          </button>
        </div>
      </Section>

      {showInvite   && <InviteModal onClose={()=>setShowInvite(false)} token={token} API={API}/>}
      {showPayments && (
        <BottomSheet title="Баланс участников" onClose={()=>setShowPayments(false)}>
          <PaymentsOverview players={players} token={token} API={API}/>
        </BottomSheet>
      )}
      {activeSession && (
        <SessionDetailSheet
          s={activeSession} locations={locations} players={players}
          onEdit={()=>{onEditSession&&onEditSession(activeSession);setActiveSession(null);}}
          onPay={()=>{onPaySession&&onPaySession(activeSession);setActiveSession(null);}}
          onManual={()=>{onManualSession&&onManualSession(activeSession);setActiveSession(null);}}
          onMessage={()=>{setMsgSession(activeSession);setActiveSession(null);}}
          onClose={()=>setActiveSession(null)}
        />
      )}
      {msgSession && <MessageComposer session={msgSession} onClose={()=>setMsgSession(null)} token={token} API={API}/>}
    </div>
  );
}

// ── CALENDAR VIEW ──────────────────────────────────────────────────────────────
const WEEK_DAYS = ["Пн","Вт","Ср","Чт","Пт","Сб","Вс"];
const HOUR_START = 8;
const HOUR_END   = 21;
const TOTAL_HOURS = HOUR_END - HOUR_START;
const PX_PER_HOUR = 64;

// Получить понедельник недели для заданной даты
const getWeekStart = (date) => {
  const d = new Date(date);
  d.setHours(0,0,0,0);
  const day = d.getDay(); // 0=вс,1=пн...
  const diff = (day === 0 ? -6 : 1 - day);
  d.setDate(d.getDate() + diff);
  return d;
};

// Получить массив из 7 дат недели начиная с понедельника
const getWeekDates = (weekStart) => {
  return Array.from({length:7}, (_,i) => {
    const d = new Date(weekStart);
    d.setDate(d.getDate() + i);
    return d;
  });
};

// map "09:00" → fractional hour offset from HOUR_START
const timeToOffset = t => {
  const [h,m] = t.split(":").map(Number);
  return (h + m/60) - HOUR_START;
};

const lvlColors = {
  "Начинающий": {bg:"#dbeafe", border:"#93c5fd", text:"#1d4ed8"},
  "Средний":    {bg:"#fef3c7", border:"#fcd34d", text:"#92400e"},
  "Продвинутый":{bg:"#ede9fe", border:"#c4b5fd", text:"#5b21b6"},
};

function CalendarView({sessions, locations, onSessionClick}) {
  const today = new Date(); today.setHours(0,0,0,0);
  const [weekStart, setWeekStart] = useState(() => getWeekStart(today));
  const weekDates = getWeekDates(weekStart);

  const locName = id => locations.find(l=>l.id===id)?.name?.split(",")[0]||"";
  const hours = Array.from({length: TOTAL_HOURS+1}, (_,i) => HOUR_START+i);

  const toISO = d => d.toISOString().slice(0,10);
  const isToday = d => toISO(d) === toISO(today);

  const prevWeek = () => { const d=new Date(weekStart); d.setDate(d.getDate()-7); setWeekStart(d); };
  const nextWeek = () => { const d=new Date(weekStart); d.setDate(d.getDate()+7); setWeekStart(d); };
  const goToday  = () => setWeekStart(getWeekStart(today));

  // Найти колонку (0-6) для тренировки по ISO-дате
  const sessionCol = s => {
    const sDate = (s.date||"").slice(0,10); // берём первые 10 символов ISO
    return weekDates.findIndex(d => toISO(d) === sDate);
  };

  const weekLabel = () => {
    const start = weekDates[0];
    const end = weekDates[6];
    if (start.getMonth() === end.getMonth()) {
      return `${start.getDate()}–${end.getDate()} ${RU_MONTHS[start.getMonth()].toLowerCase()} ${start.getFullYear()}`;
    }
    return `${start.getDate()} ${RU_MONTHS[start.getMonth()].slice(0,3).toLowerCase()} – ${end.getDate()} ${RU_MONTHS[end.getMonth()].slice(0,3).toLowerCase()} ${end.getFullYear()}`;
  };

  return (
    <div>
      {/* Навигация по неделям */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10,padding:"0 4px"}}>
        <button onClick={prevWeek} style={{background:"none",border:"none",cursor:"pointer",fontSize:20,color:C.muted,padding:"4px 10px"}}>‹</button>
        <button onClick={goToday} style={{fontSize:12,fontWeight:600,color:C.accent,background:C.accentLight,border:"none",borderRadius:8,padding:"4px 12px",cursor:"pointer"}}>
          {weekLabel()}
        </button>
        <button onClick={nextWeek} style={{background:"none",border:"none",cursor:"pointer",fontSize:20,color:C.muted,padding:"4px 10px"}}>›</button>
      </div>

      <div style={{overflowX:"auto", margin:"0 -20px"}}>
        <div style={{minWidth: 560, padding:"0 20px"}}>

          {/* Заголовки дней */}
          <div style={{display:"grid", gridTemplateColumns:"44px repeat(7,1fr)", marginBottom:0, position:"sticky", top:0, background:C.bg, zIndex:10, paddingBottom:6}}>
            <div/>
            {weekDates.map((date,i)=>(
              <div key={i} style={{textAlign:"center"}}>
                <div style={{fontSize:11, color:C.faint, fontWeight:600, textTransform:"uppercase"}}>{WEEK_DAYS[i]}</div>
                <div style={{
                  width:28, height:28, borderRadius:"50%", margin:"4px auto 0",
                  display:"flex", alignItems:"center", justifyContent:"center",
                  background: isToday(date) ? C.accent : "transparent",
                  color: isToday(date) ? "#fff" : C.text,
                  fontWeight: isToday(date) ? 700 : 500,
                  fontSize: 13,
                }}>{date.getDate()}</div>
              </div>
            ))}
          </div>

          {/* Сетка */}
          <div style={{position:"relative", display:"grid", gridTemplateColumns:"44px repeat(7,1fr)"}}>

            {/* Часы и горизонтальные линии */}
            {hours.map(h=>(
              <div key={h} style={{display:"contents"}}>
                <div style={{height: PX_PER_HOUR, display:"flex", alignItems:"flex-start", justifyContent:"flex-end", paddingRight:8, paddingTop:0}}>
                  <span style={{fontSize:10, color:C.faint, lineHeight:1, marginTop:-5}}>{h}:00</span>
                </div>
                {WEEK_DAYS.map(d=>(
                  <div key={d} style={{height:PX_PER_HOUR, borderTop:`1px solid ${C.border}`, position:"relative"}}/>
                ))}
              </div>
            ))}

            {/* Блоки тренировок */}
            {sessions.map(s=>{
              const col = sessionCol(s);
              if(col < 0) return null;
              const topOffset  = timeToOffset(s.time) * PX_PER_HOUR;
              const blockHeight = Math.max(((s.duration||60)/60) * PX_PER_HOUR - 4, 22);
              const cl = lvlColors[s.level] || lvlColors["Начинающий"];
              const leftPos  = `calc(44px + ${col} * (100% - 44px) / 7 + 3px)`;

              return (
                <div key={s.id} onClick={()=>onSessionClick(s)} style={{
                  position:"absolute",
                  top: topOffset,
                  left: leftPos,
                  width: `calc((100% - 44px) / 7 - 6px)`,
                  height: blockHeight,
                  background: cl.bg,
                  border: `1.5px solid ${cl.border}`,
                  borderRadius: 8,
                  padding: "4px 6px",
                  boxSizing: "border-box",
                  cursor: "pointer",
                  overflow: "hidden",
                  zIndex: 2,
                }}>
                  <div style={{fontWeight:700, fontSize:11, color:cl.text, lineHeight:1.2}}>{formatTime(s.time)}</div>
                  {blockHeight > 38 && <div style={{fontSize:10, color:cl.text, opacity:0.8, marginTop:2, overflow:"hidden", whiteSpace:"nowrap", textOverflow:"ellipsis"}}>{locName(s.location_id)}</div>}
                  {blockHeight > 56 && <div style={{fontSize:10, color:cl.text, opacity:0.7, marginTop:1}}>{s.duration} мин · {s.booked||0}/{s.max_players}</div>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

// ── NOTIFY AFTER EDIT MODAL ────────────────────────────────────────────────────
function NotifyEditModal({session, onYes, onNo}) {
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:400,padding:24}}>
      <div style={{background:"#fff",borderRadius:20,padding:"28px 24px",width:"100%",maxWidth:360,boxShadow:shadowMd}}>
        <div style={{fontSize:32,textAlign:"center",marginBottom:12}}>🔔</div>
        <div style={{fontWeight:800,fontSize:18,color:C.text,textAlign:"center",marginBottom:8}}>Уведомить участников?</div>
        <div style={{fontSize:14,color:C.muted,textAlign:"center",lineHeight:1.6,marginBottom:24}}>
          На тренировку <strong style={{color:C.text}}>{session.date} · {session.time}</strong> записано <strong style={{color:C.text}}>{session.booked} участников</strong>. Отправить им уведомление об изменениях?
        </div>
        <div style={{display:"flex",gap:10}}>
          <Btn full variant="neutral" onClick={onNo}>Нет, не нужно</Btn>
          <Btn full onClick={onYes}>Да, уведомить</Btn>
        </div>
      </div>
    </div>
  );
}

function CancelConfirmModal({count, totalBooked, onConfirm, onClose}) {
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:400,padding:24}}>
      <div style={{background:"#fff",borderRadius:20,padding:"28px 24px",width:"100%",maxWidth:360,boxShadow:shadowMd}}>
        <div style={{fontSize:32,textAlign:"center",marginBottom:12}}>⚠️</div>
        <div style={{fontWeight:800,fontSize:18,color:C.text,textAlign:"center",marginBottom:8}}>Отменить тренировки?</div>
        <div style={{fontSize:14,color:C.muted,textAlign:"center",lineHeight:1.6,marginBottom:16}}>
          Вы выбрали <strong style={{color:C.text}}>{count} тренировок</strong>.
          {totalBooked>0 && <> На них записано <strong style={{color:C.red}}>{totalBooked} участников</strong> — они автоматически получат уведомление об отмене.</>}
        </div>
        {totalBooked>0&&(
          <div style={{background:C.yellowLight,border:`1px solid ${C.yellow}55`,borderRadius:12,padding:"10px 14px",marginBottom:16,fontSize:13,color:C.yellow}}>
            📲 Уведомление об отмене будет отправлено автоматически всем участникам
          </div>
        )}
        <div style={{display:"flex",gap:10}}>
          <Btn full variant="neutral" onClick={onClose}>Назад</Btn>
          <Btn full variant="danger" onClick={onConfirm}>Отменить тренировки</Btn>
        </div>
      </div>
    </div>
  );
}

function Toast({message,onDone}) {
  const [vis,setVis] = useState(true);
  if(!vis) return null;
  setTimeout(()=>{setVis(false);onDone&&onDone();},3200);
  return (
    <div style={{position:"fixed",bottom:90,left:"50%",transform:"translateX(-50%)",background:C.text,color:"#fff",borderRadius:12,padding:"12px 20px",fontSize:13,fontWeight:600,zIndex:500,whiteSpace:"nowrap",boxShadow:shadowMd,display:"flex",alignItems:"center",gap:8}}>
      <span style={{fontSize:16}}>✓</span>{message}
    </div>
  );
}


// ── MANUAL PLAYER ADD MODAL ────────────────────────────────────────────────────
function ManualAddModal({session, allPlayers, onClose, onSaved, notifyOnSave=true, token, API}) {
  const [added, setAdded] = useState(new Set());
  const [saving, setSaving] = useState(false);
  const available = allPlayers.filter(p => !p.blocked);

  const toggle = id => setAdded(prev => {
    const next = new Set(prev);
    next.has(id) ? next.delete(id) : next.add(id);
    return next;
  });

  const handleSave = async () => {
    if(added.size === 0) { onClose(); return; }
    setSaving(true);
    await Promise.all([...added].map(playerId =>
      fetch(API+'/bookings/manual', {
        method: 'POST',
        headers: {'Authorization':'Bearer '+token, 'Content-Type':'application/json'},
        body: JSON.stringify({session_id: session.id, player_id: playerId})
      }).catch(()=>{})
    ));
    setSaving(false);
    onSaved && onSaved(added.size, notifyOnSave ? "✅ Участники добавлены на тренировку" : null);
    onClose();
  };

  return (
    <BottomSheet title="Добавить участников" onClose={onClose}>
      <div style={{background:C.accentLight,borderRadius:12,padding:"10px 14px",marginBottom:16,fontSize:13,color:C.accent}}>
        📅 {session.date||"Новая"} · {session.time} · <strong>{session.level}</strong>
        {session.booked!=null && <div style={{fontSize:12,color:C.muted,marginTop:2}}>Свободно мест: {session.max - session.booked}</div>}
      </div>

      {available.length === 0 && (
        <div style={{textAlign:"center",padding:"30px 0",color:C.muted}}>
          <div style={{fontSize:32,marginBottom:8}}>👤</div>
          <div style={{fontWeight:600,fontSize:14,color:C.text}}>Нет доступных участников</div>
          <div style={{fontSize:12,marginTop:4}}>Все участники уровня «{session.level}» уже записаны или заблокированы</div>
        </div>
      )}

      {available.map(p => {
        const isAdded = added.has(p.id);
        return (
          <div key={p.id} style={{background:isAdded?C.greenLight:C.card,border:`1.5px solid ${isAdded?C.green+"55":C.border}`,borderRadius:14,padding:"12px 14px",marginBottom:10,display:"flex",justifyContent:"space-between",alignItems:"center",transition:"all 0.15s"}}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <div style={{width:38,height:38,borderRadius:"50%",background:isAdded?C.greenDim:C.accentDim,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:15,color:isAdded?C.green:C.accent}}>{p.name[0]}</div>
              <div>
                <div style={{fontWeight:700,fontSize:14,color:C.text}}>{p.name}</div>
                <div style={{fontSize:12,color:C.muted}}>{p.username} · {p.sessions} тренировок</div>
              </div>
            </div>
            <button onClick={()=>toggle(p.id)} style={{background:isAdded?C.greenDim:C.accentDim,border:"none",borderRadius:10,padding:"7px 14px",fontSize:13,fontWeight:700,color:isAdded?C.green:C.accent,cursor:"pointer",whiteSpace:"nowrap"}}>
              {isAdded ? "✓ Добавлен" : "+ Добавить"}
            </button>
          </div>
        );
      })}

      {added.size > 0 && (
        <div style={{marginTop:8}}>
          <div style={{background:notifyOnSave?C.greenLight:C.yellowLight,border:`1px solid ${notifyOnSave?C.green:C.yellow}33`,borderRadius:12,padding:"10px 14px",marginBottom:10,fontSize:12,color:notifyOnSave?C.green:C.yellow}}>
            {notifyOnSave
              ? "📲 Участники сразу получат уведомление с деталями тренировки"
              : "⏳ Уведомления отправятся когда вы нажмёте «Создать тренировку»"}
          </div>
          <Btn full onClick={handleSave}>
            {notifyOnSave ? "Сохранить и уведомить" : "Подтвердить"} ({added.size} {added.size===1?"участник":"участников"})
          </Btn>
        </div>
      )}
    </BottomSheet>
  );
}


// ── CHAIN CANCEL MODAL ─────────────────────────────────────────────────────────
function ChainCancelModal({session, onConfirm, onClose}) {
  const totalBooked = session.booked; // in real app: sum across all recurring instances
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:400,padding:24}}>
      <div style={{background:"#fff",borderRadius:20,padding:"28px 24px",width:"100%",maxWidth:360,boxShadow:shadowMd}}>
        <div style={{fontSize:32,textAlign:"center",marginBottom:12}}>🔁</div>
        <div style={{fontWeight:800,fontSize:18,color:C.text,textAlign:"center",marginBottom:8}}>Удалить всю цепочку?</div>
        <div style={{background:C.accentLight,borderRadius:12,padding:"10px 14px",marginBottom:14,fontSize:13,color:C.accent,textAlign:"center"}}>
          {session.date} · {session.time} · {session.repeatUntil?"до "+session.repeatUntil:"бессрочно"}
        </div>
        <div style={{fontSize:14,color:C.muted,textAlign:"center",lineHeight:1.6,marginBottom:14}}>
          Будут удалены все будущие повторения этой тренировки.
          {totalBooked>0&&<> Участники каждой тренировки получат уведомление об отмене.</>}
        </div>
        <div style={{display:"flex",gap:8,marginBottom:10}}>
          <Btn full variant="ghost" onClick={()=>{onConfirm(0);}}>Только эту</Btn>
          <Btn full variant="danger" onClick={()=>onConfirm(totalBooked)}>Всю цепочку</Btn>
        </div>
        <Btn full variant="neutral" onClick={onClose}>Отмена</Btn>
      </div>
    </div>
  );
}

// Оплата тренировки — список участников с отметкой оплаты
function SessionPaymentModal({session, onClose, token, API}) {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [prices, setPrices]     = useState({}); // overrides per player
  const [paid, setPaid]         = useState({}); // paid status per booking id
  const [saving, setSaving]     = useState({});

  useEffect(()=>{
    fetch(`${API}/sessions/${session.id}/bookings`, {headers:{'Authorization':'Bearer '+token}})
      .then(r=>r.json())
      .then(data=>{
        if(Array.isArray(data)) {
          setBookings(data);
          // Загружаем существующие оплаты
          fetch(`${API}/payments?session_id=${session.id}`, {headers:{'Authorization':'Bearer '+token}})
            .then(r=>r.json())
            .then(payments=>{
              if(Array.isArray(payments)) {
                const paidMap = {};
                payments.forEach(p=>{ paidMap[p.player_id] = {id:p.id, paid:p.paid}; });
                setPaid(paidMap);
              }
            }).catch(()=>{});
        }
        setLoading(false);
      }).catch(()=>setLoading(false));
  },[session.id]);

  const togglePaid = async (booking) => {
    const playerId = booking.player_id;
    const existing = paid[playerId];
    setSaving(s=>({...s,[playerId]:true}));

    if(existing) {
      // Обновляем существующую запись
      const newVal = !existing.paid;
      await fetch(`${API}/payments/${existing.id}`, {
        method:'PATCH',
        headers:{'Authorization':'Bearer '+token,'Content-Type':'application/json'},
        body: JSON.stringify({paid: newVal})
      }).catch(()=>{});
      setPaid(p=>({...p,[playerId]:{...existing,paid:newVal}}));
    } else {
      // Создаём новую запись об оплате
      const amount = prices[playerId] ?? session.price;
      const r = await fetch(`${API}/payments`, {
        method:'POST',
        headers:{'Authorization':'Bearer '+token,'Content-Type':'application/json'},
        body: JSON.stringify({player_id: playerId, session_id: session.id, amount, paid: true})
      }).catch(()=>{});
      if(r?.ok) {
        const data = await r.json();
        setPaid(p=>({...p,[playerId]:{id:data.id,paid:true}}));
      }
    }
    setSaving(s=>({...s,[playerId]:false}));
  };

  return (
    <BottomSheet title="💳 Оплата тренировки" onClose={onClose}>
      <div style={{background:C.accentLight,borderRadius:12,padding:"10px 14px",marginBottom:16,fontSize:13,color:C.accent,fontWeight:500}}>
        {formatDate(session.date)} · {formatTime(session.time)} · {session.price}₽ за участника
      </div>
      {loading&&<div style={{textAlign:"center",padding:20,color:C.muted}}>Загрузка...</div>}
      {!loading&&bookings.length===0&&(
        <div style={{textAlign:"center",padding:20,color:C.muted,fontSize:13}}>Никто не записан на эту тренировку</div>
      )}
      {bookings.map(b=>{
        const isPaid = paid[b.player_id]?.paid;
        const isSaving = saving[b.player_id];
        const amount = prices[b.player_id] ?? session.price;
        return (
          <div key={b.id} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",borderBottom:`1px solid ${C.border}`}}>
            <div style={{width:36,height:36,borderRadius:"50%",background:C.accentDim,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:14,color:C.accent,flexShrink:0}}>
              {(b.name||"?")[0].toUpperCase()}
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:14,fontWeight:600,color:C.text}}>{b.name}</div>
              <input type="number" value={amount}
                onChange={e=>setPrices(p=>({...p,[b.player_id]:Number(e.target.value)}))}
                style={{width:80,border:`1px solid ${C.border}`,borderRadius:8,padding:"4px 8px",fontSize:13,color:C.text,background:"#fff",outline:"none",marginTop:3}}
              />
              <span style={{fontSize:12,color:C.muted,marginLeft:4}}>₽</span>
            </div>
            <button onClick={()=>togglePaid(b)} disabled={isSaving}
              style={{padding:"8px 14px",borderRadius:10,border:"none",cursor:isSaving?"wait":"pointer",
                background:isPaid?C.greenDim:"#fff",border:`1.5px solid ${isPaid?C.green:C.border}`,
                color:isPaid?C.green:C.muted,fontWeight:600,fontSize:13,flexShrink:0}}>
              {isSaving?"...":isPaid?"✓ Оплачено":"Отметить"}
            </button>
          </div>
        );
      })}
    </BottomSheet>
  );
}

// Список записавшихся на тренировку
function SessionBookingsList({sessionId, token, API}) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    if(!sessionId||!token) return;
    fetch(`${API}/sessions/${sessionId}/bookings`, {headers:{'Authorization':'Bearer '+token}})
      .then(r=>r.json())
      .then(data=>{ if(Array.isArray(data)) setList(data); setLoading(false); })
      .catch(()=>setLoading(false));
  },[sessionId]);

  if(loading) return <div style={{fontSize:12,color:C.muted,textAlign:"center",padding:"8px 0"}}>Загрузка...</div>;
  if(list.length===0) return (
    <div style={{background:C.bg,borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,color:C.muted}}>
      Никто ещё не записался
    </div>
  );

  return (
    <div style={{marginBottom:12}}>
      <div style={{fontSize:11,color:C.faint,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8}}>
        Записались ({list.length})
      </div>
      {list.map(b=>(
        <div key={b.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",background:C.bg,borderRadius:10,marginBottom:6}}>
          <div style={{width:32,height:32,borderRadius:"50%",background:C.accentDim,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:13,color:C.accent,flexShrink:0}}>
            {(b.name||"?")[0].toUpperCase()}
          </div>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:C.text}}>{b.name}</div>
            {b.username&&<div style={{fontSize:11,color:C.muted}}>@{b.username}</div>}
          </div>
          {b.level&&<Chip label={b.level} style={{marginLeft:"auto"}}/>}
        </div>
      ))}
    </div>
  );
}

function CoachSessions({sessions,locations,onAdd,players,token,API,setSessions}) {
  const [selSession,setSelSession]     = useState(null);
  const [editSession,setEditSession]   = useState(null);
  const [editingForm,setEditingForm]   = useState(null);
  const [manualSession,setManualSession] = useState(null);
  const [msgSession,setMsgSession]         = useState(null);
  const [chainCancel,setChainCancel]       = useState(null);
  const [paySession,setPaySession]     = useState(null);
  const [selectMode,setSelectMode]     = useState(false);
  const [selected,setSelected]         = useState(new Set());
  const [showCancel,setShowCancel]     = useState(false);
  const [showChainDelete,setShowChainDelete] = useState(null); // session object
  const [toast,setToast]               = useState(null);
  const [showArchive,setShowArchive]   = useState(false);
  const locName = id => locations.find(l=>l.id===id)?.name||"";

  const today = new Date(); today.setHours(0,0,0,0);
  const isExpired = s => {
    const iso = (s.date||"").slice(0,10);
    if(!iso) return false;
    const [y,mo,d] = iso.split("-").map(Number);
    const sessionDay = new Date(y,mo-1,d);
    const nextDay = new Date(sessionDay); nextDay.setDate(sessionDay.getDate()+1);
    return nextDay <= today;
  };

  const upcoming = sessions.filter(s=>!isExpired(s));
  const archived = sessions.filter(s=>isExpired(s)).sort((a,b)=>(b.date||"").localeCompare(a.date||""));

  const toggleSelect = id => setSelected(prev=>{const n=new Set(prev);n.has(id)?n.delete(id):n.add(id);return n;});

  // Called when user saves the edit form
  const handleEditSave = s => {
    setEditingForm(null);
    setSelSession(null);
    if(s.booked>0) setEditSession(s);
    else setToast("Изменения сохранены");
  };

  const handleNotifyYes = () => { const s=editSession; setEditSession(null); setToast(`Уведомление отправлено ${s.booked} участникам`); };
  const handleNotifyNo  = () => { setEditSession(null); setToast("Изменения сохранены"); };

  const confirmCancel = async () => {
    const tb=sessions.filter(s=>selected.has(s.id)).reduce((a,s)=>a+(s.booked||0),0);
    const ids = [...selected];
    setShowCancel(false); setSelectMode(false); setSelected(new Set());
    await Promise.all(ids.map(id =>
      fetch(`${API}/sessions/${id}`, {
        method: 'DELETE',
        headers: {'Authorization':'Bearer '+token}
      }).catch(()=>{})
    ));
    setSessions(prev => prev.filter(s => !ids.includes(s.id)));
    setToast(tb>0?`Тренировки отменены · уведомлено ${tb} участников`:"Тренировки отменены");
  };

  const deleteOne = async (s) => {
    setShowChainDelete(null); setSelSession(null);
    await fetch(`${API}/sessions/${s.id}`, {method:'DELETE',headers:{'Authorization':'Bearer '+token}}).catch(()=>{});
    setSessions(prev=>prev.filter(x=>x.id!==s.id));
    setToast("Тренировка отменена");
  };

  const deleteChain = async (s) => {
    setShowChainDelete(null); setSelSession(null);
    const groupId = s.repeat_group_id || s.id;
    await fetch(`${API}/sessions/chain/${groupId}`, {method:'DELETE',headers:{'Authorization':'Bearer '+token}}).catch(()=>{});
    setSessions(prev=>prev.filter(x=>x.repeat_group_id!==groupId && x.id!==groupId));
    setToast("Цепочка тренировок отменена");
  };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,gap:6}}>
        <div style={{display:"flex",gap:6,marginLeft:"auto"}}>
          <Btn small variant={selectMode?"neutral":"ghost"} onClick={()=>{setSelectMode(!selectMode);setSelected(new Set());}}>{selectMode?"Отмена":"Выбрать"}</Btn>
          {!selectMode&&<Btn small onClick={onAdd}>+ Добавить</Btn>}
        </div>
      </div>

      {selectMode&&(
        <div style={{background:C.accentLight,border:`1px solid ${C.accent}44`,borderRadius:14,padding:"12px 16px",marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontSize:13,color:C.accent,fontWeight:600}}>{selected.size===0?"Выберите тренировки для отмены":`Выбрано: ${selected.size}`}</span>
          {selected.size>0&&<Btn small variant="danger" onClick={()=>setShowCancel(true)}>🗑 Отменить выбранные</Btn>}
        </div>
      )}

      {(()=>{
        if(upcoming.length===0 && archived.length===0) return (
          <div style={{textAlign:"center",padding:"48px 24px",color:C.muted}}>
            <div style={{fontSize:40,marginBottom:12}}>📅</div>
            <div style={{fontWeight:700,fontSize:16,color:C.text,marginBottom:6}}>Нет тренировок</div>
            <div style={{fontSize:14}}>Нажмите «+ Добавить» чтобы создать первую тренировку</div>
          </div>
        );

        const toISO = d => localISO(d);
        const todayISO = localISO(today);
        const tomorrowISO = localISO(new Date(today.getTime()+86400000));

        const groups = {};
        [...upcoming].sort((a,b)=>(a.date||"").localeCompare(b.date||"")).forEach(s=>{
          const key = (s.date||"").slice(0,10);
          if(!groups[key]) groups[key]=[];
          groups[key].push(s);
        });

        const dayLabel = (iso) => {
          if(iso===todayISO) return "Сегодня — "+formatDate(iso);
          if(iso===tomorrowISO) return "Завтра — "+formatDate(iso);
          return formatDate(iso);
        };

        const SessionRow = (s) => {
          const cl = lvlColors[s.level]||lvlColors["Начинающий"];
          const isSel = selected.has(s.id);
          return (
            <div key={s.id} onClick={()=>selectMode?toggleSelect(s.id):setSelSession(s)}
              style={{background:C.card,borderRadius:14,border:`1.5px solid ${selectMode&&isSel?C.accent:C.border}`,boxShadow:selectMode&&isSel?`0 0 0 3px ${C.accentDim}`:shadow,padding:"12px 14px",marginBottom:8,display:"flex",alignItems:"center",gap:12,cursor:"pointer"}}>
              {selectMode&&(
                <div style={{width:20,height:20,borderRadius:6,border:`2px solid ${isSel?C.accent:C.borderStrong}`,background:isSel?C.accent:"#fff",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  {isSel&&<span style={{color:"#fff",fontSize:12}}>✓</span>}
                </div>
              )}
              <div style={{width:10,height:10,borderRadius:"50%",background:cl.border,flexShrink:0}}/>
              <div style={{fontWeight:700,fontSize:15,color:C.text,minWidth:46}}>{formatTime(s.time)}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,color:C.text}}>{s.level}</div>
                <div style={{fontSize:11,color:C.muted,marginTop:2,display:"flex",alignItems:"center",gap:4,flexWrap:"wrap"}}>
                  <span>{s.duration} мин{locName(s.location_id)?` · ${locName(s.location_id)}`:""}</span>
                  {(s.repeat_weekly||s.repeat)&&<span style={{background:"#FEF3C7",color:"#92400E",fontSize:10,fontWeight:500,padding:"1px 6px",borderRadius:20,flexShrink:0}}>↻ еженедельно</span>}
                  {(s.free_slot||s.free)&&<span style={{background:"#D1FAE5",color:"#065F46",fontSize:10,fontWeight:500,padding:"1px 6px",borderRadius:20,flexShrink:0}}>✦ открытая</span>}
                </div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontSize:13,fontWeight:700,color:C.accent}}>{s.price?s.price+"₽":"Бесплатно"}</div>
                <div style={{fontSize:11,color:C.muted,marginTop:2}}>{parseInt(s.booked||0)}/{s.max_players} мест</div>
              </div>
            </div>
          );
        };

        return (<>
          {upcoming.length===0 && (
            <div style={{textAlign:"center",padding:"32px 24px 16px",color:C.muted}}>
              <div style={{fontSize:14}}>Нет предстоящих тренировок</div>
            </div>
          )}
          {Object.entries(groups).map(([iso, daySessions])=>(
            <div key={iso}>
              <div style={{fontSize:11,color:C.faint,fontWeight:600,padding:"12px 0 4px",letterSpacing:"0.05em",textTransform:"uppercase"}}>{dayLabel(iso)}</div>
              {daySessions.map(s=>SessionRow(s))}
            </div>
          ))}

          {archived.length>0&&(
            <div style={{marginTop:16}}>
              <button onClick={()=>setShowArchive(!showArchive)} style={{width:"100%",background:C.bg,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",color:C.muted,fontSize:14,fontWeight:600}}>
                <span>🗄 Архив тренировок ({archived.length})</span>
                <span style={{fontSize:12}}>{showArchive?"▲":"▼"}</span>
              </button>
              {showArchive&&(
                <div style={{marginTop:8}}>
                  {archived.map(s=>(
                    <div key={s.id} style={{opacity:0.6}}>
                      {SessionRow(s)}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </>);
      })()}

      {selSession&&(
        <BottomSheet title="Тренировка" onClose={()=>setSelSession(null)}>
          {(()=>{const s=selSession;const cl=lvlColors[s.level]||lvlColors["Начинающий"];return(<>
            <div style={{background:cl.bg,border:`1px solid ${cl.border}`,borderRadius:14,padding:"14px 16px",marginBottom:16}}>
              <div style={{fontWeight:800,fontSize:22,color:cl.text}}>{formatTime(s.time)} <span style={{fontSize:14,fontWeight:400}}>· {s.duration} мин</span></div>
              <div style={{fontSize:13,color:cl.text,opacity:0.8,marginTop:4}}>{formatDate(s.date)}</div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
              {[{l:"Локация",v:"📍 "+(locName(s.location_id)||"—")},{l:"Стоимость",v:s.price?s.price+"₽":"Бесплатно"},{l:"Участники",v:`${parseInt(s.booked||s.booked_count||0)} из ${parseInt(s.max_players||s.max||0)}`},{l:"Уровень",v:s.level}].map(x=>(
                <div key={x.l} style={{background:C.bg,borderRadius:12,padding:"10px 12px"}}>
                  <div style={{fontSize:11,color:C.faint,marginBottom:3}}>{x.l}</div>
                  <div style={{fontWeight:700,fontSize:13,color:C.text}}>{x.v}</div>
                </div>
              ))}
            </div>
            <SessionBookingsList sessionId={s.id} token={token} API={API}/>
            <div style={{display:"flex",gap:8,marginBottom:8}}>
              <Btn full variant="ghost" onClick={()=>{setEditingForm(s);setSelSession(null);}}>✏️ Изменить</Btn>
              <Btn full variant="warning" onClick={()=>{setMsgSession(s);setSelSession(null);}}>✉️ Написать участникам</Btn>
            </div>
            {s.price>0&&<Btn full variant="success" style={{marginBottom:8}} onClick={()=>{setPaySession(s);setSelSession(null);}}>💳 Оплата</Btn>}
            <Btn full style={{background:C.purpleDim,color:C.purple,border:"none"}} onClick={()=>{setManualSession(s);setSelSession(null);}}>👤 Добавить участников вручную</Btn>
            <div style={{marginTop:8}}>
              <Btn full variant="danger" onClick={()=>{
                if(s.repeat_group_id) { setShowChainDelete(s); setSelSession(null); }
                else deleteOne(s);
              }}>🗑 Отменить тренировку</Btn>
            </div>
          </>);})()}
        </BottomSheet>
      )}

      {editingForm&&<SessionFormModal session={editingForm} locations={locations} onClose={()=>setEditingForm(null)} onSave={(updated)=>{setSessions(prev=>prev.map(s=>s.id===updated.id?updated:s));handleEditSave(updated);}} formPlayers={players} token={token} API={API}/>}
      {manualSession&&<ManualAddModal session={manualSession} allPlayers={players} onClose={()=>setManualSession(null)} onSaved={(n,msg)=>setToast(msg)} token={token} API={API}/>}
      {paySession&&<SessionPaymentModal session={paySession} onClose={()=>setPaySession(null)} token={token} API={API}/>}
      {editSession&&<NotifyEditModal session={editSession} onYes={handleNotifyYes} onNo={handleNotifyNo}/>}
      {showCancel&&<CancelConfirmModal count={selected.size} totalBooked={sessions.filter(s=>selected.has(s.id)).reduce((a,s)=>a+s.booked,0)} onConfirm={confirmCancel} onClose={()=>setShowCancel(false)}/>}
      {showChainDelete&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:400,padding:24}}>
          <div style={{background:"#fff",borderRadius:20,padding:"24px 20px",width:"100%",maxWidth:360}}>
            <div style={{fontSize:28,textAlign:"center",marginBottom:10}}>🔁</div>
            <div style={{fontWeight:700,fontSize:17,color:C.text,textAlign:"center",marginBottom:8}}>Повторяющаяся тренировка</div>
            <div style={{fontSize:14,color:C.muted,textAlign:"center",marginBottom:20,lineHeight:1.6}}>
              Что вы хотите отменить?
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              <Btn full variant="danger" onClick={()=>deleteOne(showChainDelete)}>Только эту тренировку</Btn>
              <Btn full variant="danger" onClick={()=>deleteChain(showChainDelete)}>Всю цепочку</Btn>
              <Btn full variant="neutral" onClick={()=>setShowChainDelete(null)}>Отмена</Btn>
            </div>
          </div>
        </div>
      )}
      {msgSession&&<MessageComposer session={msgSession} onClose={()=>setMsgSession(null)} token={token} API={API}/>}
      {chainCancel&&<ChainCancelModal session={chainCancel} onConfirm={(tb)=>{setToast(tb>0?"Цепочка отменена · уведомлено "+tb+" участников":"Цепочка тренировок отменена");setChainCancel(null);}} onClose={()=>setChainCancel(null)}/>}
      {toast&&<Toast message={toast} onDone={()=>setToast(null)}/>}
    </div>
  );
}

function CoachPlayers({players,setPlayers,levels,token,API}) {
  const [sel,setSel]           = useState(null);
  const [editingName,setEditingName] = useState(null);
  const [nameDraft,setNameDraft]     = useState("");

  const toggleBlock = async (id) => {
    const p = players.find(x=>x.id===id);
    const newVal = !p.blocked;
    setPlayers(ps=>ps.map(p=>p.id===id?{...p,blocked:newVal}:p));
    await fetch(`${API}/players/${id}/block`, {
      method:'PATCH',
      headers:{'Authorization':'Bearer '+token,'Content-Type':'application/json'},
      body: JSON.stringify({blocked: newVal})
    }).catch(()=>{});
  };

  const changeLevel = async (id, lvl) => {
    setPlayers(ps=>ps.map(p=>p.id===id?{...p,level:lvl}:p));
    await fetch(`${API}/players/${id}/level`, {
      method:'PATCH',
      headers:{'Authorization':'Bearer '+token,'Content-Type':'application/json'},
      body: JSON.stringify({level: lvl})
    }).catch(()=>{});
  };

  const saveName = id => { setPlayers(ps=>ps.map(p=>p.id===id?{...p,coachName:nameDraft||p.name}:p)); setEditingName(null); };

  const levelList = levels && levels.length>0 ? levels : ["Начинающий","Средний","Продвинутый"];

  return (
    <div>
      <div style={{fontSize:11,fontWeight:700,color:C.faint,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:14}}>Участники ({players.length})</div>
      {players.map(p=>(
        <Card key={p.id}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <div style={{width:42,height:42,borderRadius:"50%",background:p.blocked?C.redDim:C.accentDim,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:16,color:p.blocked?C.red:C.accent,flexShrink:0}}>{p.name[0]}</div>
              <div>
                <div style={{fontWeight:700,fontSize:14,color:C.text}}>
                  {p.coachName||p.name}
                  {p.coachName&&p.coachName!==p.name&&<span style={{fontSize:11,color:C.faint,fontWeight:400,marginLeft:6}}>({p.name})</span>}
                </div>
                <div style={{fontSize:12,color:C.muted,marginTop:2,display:"flex",alignItems:"center",gap:6}}>
                  <span>{p.username}</span>
                  <Chip label={p.level} small/>
                </div>
              </div>
            </div>
            <button onClick={()=>setSel(sel===p.id?null:p.id)} style={{background:C.bg,border:`1px solid ${C.border}`,color:C.muted,borderRadius:10,padding:"5px 12px",fontSize:12,cursor:"pointer",whiteSpace:"nowrap"}}>
              {sel===p.id?"Скрыть":"Подробнее"}
            </button>
          </div>

          {p.blocked&&(
            <div style={{marginTop:8,background:C.redLight,borderRadius:8,padding:"6px 10px",fontSize:12,color:C.red}}>⛔ Запись на тренировки заблокирована</div>
          )}

          {sel===p.id&&(
            <div style={{marginTop:14,borderTop:`1px solid ${C.border}`,paddingTop:14}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:16}}>
                {[
                  {v:p.level||"—",l:"уровень"},
                  {v:p.blocked?"Заблокирован":"Активен",l:"статус",c:p.blocked?C.red:C.green}
                ].map(x=>(
                  <div key={x.l} style={{background:C.bg,borderRadius:10,padding:"10px 6px",textAlign:"center"}}>
                    <div style={{fontWeight:800,fontSize:14,color:x.c||C.text}}>{x.v}</div>
                    <div style={{fontSize:10,color:C.faint,marginTop:2}}>{x.l}</div>
                  </div>
                ))}
              </div>

              {/* Name edit */}
              <div style={{marginBottom:14}}>
                <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:6}}>Имя для вас</div>
                {editingName===p.id ? (
                  <div style={{display:"flex",gap:8}}>
                    <input autoFocus value={nameDraft} onChange={e=>setNameDraft(e.target.value)}
                      onKeyDown={e=>e.key==="Enter"&&saveName(p.id)}
                      style={{flex:1,border:`1.5px solid ${C.accent}`,borderRadius:10,padding:"8px 12px",fontSize:14,color:C.text,background:"#fff",outline:"none"}}/>
                    <button onClick={()=>saveName(p.id)} style={{background:C.accent,border:"none",borderRadius:10,padding:"8px 14px",fontSize:13,fontWeight:700,color:"#fff",cursor:"pointer"}}>OK</button>
                    <button onClick={()=>setEditingName(null)} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:10,padding:"8px 10px",fontSize:13,color:C.muted,cursor:"pointer"}}>✕</button>
                  </div>
                ) : (
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:C.bg,borderRadius:10,padding:"9px 12px"}}>
                    <span style={{fontSize:14,color:C.text,fontWeight:600}}>{p.coachName||p.name}</span>
                    <button onClick={()=>{setEditingName(p.id);setNameDraft(p.coachName||p.name);}} style={{background:"#fff",border:`1px solid ${C.border}`,borderRadius:8,padding:"4px 10px",fontSize:12,color:C.muted,cursor:"pointer"}}>✏️</button>
                  </div>
                )}
                {p.coachName&&p.coachName!==p.name&&(
                  <div style={{fontSize:11,color:C.faint,marginTop:4}}>Оригинальное имя: {p.name}</div>
                )}
              </div>

              {/* Level selector */}
              <div style={{marginBottom:12}}>
                <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:7}}>Уровень</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {levelList.map(lvl=>{
                    const s=lvlCfg(lvl);
                    const active=p.level===lvl;
                    return (
                      <button key={lvl} onClick={()=>changeLevel(p.id,lvl)} style={{
                        flex:"1 0 auto", padding:"8px 10px", borderRadius:10,
                        border:`1.5px solid ${active?s.tx:C.border}`,
                        background:active?s.bg:"#fff",
                        color:active?s.tx:C.muted,
                        fontSize:12, fontWeight:700, cursor:"pointer",
                        transition:"all 0.15s",
                      }}>{lvl}</button>
                    );
                  })}
                </div>
              </div>

              <Btn full small variant={p.blocked?"success":"danger"} onClick={()=>toggleBlock(p.id)}>
                {p.blocked?"✓ Разблокировать запись":"🚫 Заблокировать запись"}
              </Btn>
            </div>
          )}
        </Card>
      ))}
    </div>
  );
}

function CoachSettings({locations,setLocations,players,setPlayers,levels,setLevels,token,API}) {
  const [section,setSection] = useState(null);
  const [newLevel,setNewLevel] = useState("");
  const [inviteCode,setInviteCode] = useState(null);
  const [inviteCopied,setInviteCopied] = useState(false);

  useEffect(()=>{
    if(token) fetch(API+'/coach/invite',{headers:{'Authorization':'Bearer '+token}})
      .then(r=>r.json()).then(d=>setInviteCode(d.invite_code)).catch(()=>{});
  },[token]);
  const [editId,setEditId] = useState(null);
  const [editVal,setEditVal] = useState("");

  const BackBtn = () => (
    <button onClick={()=>setSection(null)} style={{display:"flex",alignItems:"center",gap:6,background:"none",border:"none",color:C.accent,fontSize:14,fontWeight:600,cursor:"pointer",marginBottom:16,padding:0}}>← Настройки</button>
  );

  if(section==="locations") return <div><BackBtn/><LocationManager locations={locations} setLocations={setLocations} token={token} API={API}/></div>;
  if(section==="payments")  return <div><BackBtn/><PaymentsOverview players={players} token={token} API={API}/></div>;

  if(section==="levels") return (
    <div>
      <BackBtn/>
      <Section title="Уровни участников">
        <div style={{fontSize:13,color:C.muted,marginBottom:14,lineHeight:1.5}}>Эти уровни будут доступны при создании тренировки и назначении участникам.</div>
        {levels.map((lvl,i)=>(
          <div key={i} style={{background:C.card,borderRadius:14,border:`1px solid ${C.border}`,padding:"12px 14px",marginBottom:10,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            {editId===i ? (
              <>
                <input autoFocus value={editVal} onChange={e=>setEditVal(e.target.value)}
                  onKeyDown={e=>e.key==="Enter"&&(setLevels(ls=>ls.map((l,j)=>j===i?editVal:l)),setEditId(null))}
                  style={{flex:1,border:`1.5px solid ${C.accent}`,borderRadius:8,padding:"7px 10px",fontSize:14,color:C.text,marginRight:8}}/>
                <Btn small onClick={()=>{setLevels(ls=>ls.map((l,j)=>j===i?editVal:l));setEditId(null);}}>Сохранить</Btn>
              </>
            ) : (
              <>
                <span style={{fontWeight:600,fontSize:14,color:C.text}}>{lvl}</span>
                <div style={{display:"flex",gap:8}}>
                  <button onClick={()=>{setEditId(i);setEditVal(lvl);}} style={{background:C.accentDim,border:"none",borderRadius:8,padding:"5px 10px",fontSize:12,color:C.accent,cursor:"pointer"}}>✏️</button>
                  <button onClick={()=>setLevels(ls=>ls.filter((_,j)=>j!==i))} style={{background:C.redDim,border:"none",borderRadius:8,padding:"5px 10px",fontSize:12,color:C.red,cursor:"pointer"}}>✕</button>
                </div>
              </>
            )}
          </div>
        ))}
        <div style={{display:"flex",gap:8,marginTop:4}}>
          <input value={newLevel} onChange={e=>setNewLevel(e.target.value)} placeholder="Новый уровень..."
            onKeyDown={e=>e.key==="Enter"&&newLevel.trim()&&(setLevels(ls=>[...ls,newLevel.trim()]),setNewLevel(""))}
            style={{flex:1,border:`1.5px solid ${C.border}`,borderRadius:10,padding:"10px 12px",fontSize:14,color:C.text,background:"#fff"}}/>
          <Btn onClick={()=>{if(newLevel.trim()){setLevels(ls=>[...ls,newLevel.trim()]);setNewLevel("");}}} disabled={!newLevel.trim()}>Добавить</Btn>
        </div>
      </Section>
    </div>
  );

  const items = [
    {id:"invite",   icon:"🔗",title:"Пригласительная ссылка", sub:"Поделитесь с участниками",     action:true},
    {id:"levels",   icon:"🏅",title:"Настроить уровни",        sub:`${levels.length} уровней`},
    {id:"locations",icon:"📍",title:"Управление локациями",    sub:`${locations.length} локации`},
    {id:"payments", icon:"💳",title:"Оплаты",                  sub:"Баланс участников"},
  ];

  return (
    <div>
      <Section title="Настройки тренера">
        {items.map(item=>(
          <div key={item.id} onClick={()=>!item.action&&setSection(item.id)} style={{background:C.card,borderRadius:14,border:`1px solid ${C.border}`,boxShadow:shadow,padding:"14px 16px",marginBottom:10,display:"flex",justifyContent:"space-between",alignItems:"center",cursor:item.action?"default":"pointer"}}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <div style={{fontSize:22}}>{item.icon}</div>
              <div>
                <div style={{fontWeight:700,fontSize:14,color:C.text}}>{item.title}</div>
                <div style={{fontSize:12,color:C.muted}}>{item.sub}</div>
              </div>
            </div>
            {item.action ? <Btn small variant="ghost">Копировать</Btn> : <span style={{color:C.faint,fontSize:18}}>›</span>}
          </div>
        ))}
      </Section>
      <div style={{background:C.accentLight,borderRadius:14,padding:"14px 16px",border:`1px solid ${C.accent}33`}}>
        <div style={{fontWeight:700,fontSize:13,color:C.accent,marginBottom:4}}>🔗 Ваша ссылка для участников</div>
        <div style={{fontSize:12,color:C.muted,marginBottom:10,lineHeight:1.5}}>Отправьте эту ссылку каждому участнику. После перехода по ней участник будет видеть только ваши тренировки.</div>
        <div style={{background:"#fff",border:`1px solid ${C.border}`,borderRadius:10,padding:"10px 12px",fontSize:13,color:C.muted,fontFamily:"monospace",wordBreak:"break-all"}}>
          {inviteCode ? `https://t.me/mycoachspace_bot?start=${inviteCode}` : "Загрузка..."}
        </div>
        <div style={{marginTop:10}}><Btn full small onClick={()=>{
          const link=inviteCode?`https://t.me/mycoachspace_bot?start=${inviteCode}`:"";
          if(link){navigator.clipboard?.writeText(link).catch(()=>{});setInviteCopied(true);setTimeout(()=>setInviteCopied(false),2500);}
        }}>{inviteCopied?"✓ Скопировано!":"Скопировать ссылку"}</Btn></div>
      </div>
    </div>
  );
}

// ── PLAYER VIEWS ───────────────────────────────────────────────────────────────

// ── PLAYER NOTIFICATIONS ───────────────────────────────────────────────────────
function PlayerNotifications() {
  // Default notification state — can be edited or deleted
  const [defaultNotif, setDefaultNotif] = useState({active:true, type:"time", value:"09:00"});
  const [editingDefault, setEditingDefault] = useState(false);
  const [editDefaultTime, setEditDefaultTime] = useState("09:00");

  const [custom, setCustom]   = useState(null);
  const [adding, setAdding]   = useState(false);
  const [editingCustom, setEditingCustom] = useState(false);
  const [addType, setAddType] = useState("hours");
  const [addHours, setAddHours] = useState(2);
  const [addTime,  setAddTime]  = useState("08:00");

  const saveCustom = () => {
    setCustom(addType==="hours" ? {type:"hours",value:addHours} : {type:"time",value:addTime});
    setAdding(false); setEditingCustom(false);
  };

  const hrWord = h => h===1?"час":h<5?"часа":"часов";

  const NotifCard = ({icon,title,sub,onEdit,onDelete}) => (
    <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:"14px 16px",marginBottom:10,boxShadow:shadow}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{width:40,height:40,borderRadius:12,background:C.accentLight,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>{icon}</div>
          <div>
            <div style={{fontWeight:700,fontSize:14,color:C.text}}>{title}</div>
            <div style={{fontSize:12,color:C.muted,marginTop:2}}>{sub}</div>
          </div>
        </div>
        <div style={{display:"flex",gap:6}}>
          <button onClick={onEdit} style={{background:C.accentDim,border:"none",borderRadius:8,padding:"5px 10px",fontSize:12,color:C.accent,cursor:"pointer"}}>✏️</button>
          <button onClick={onDelete} style={{background:C.redDim,border:"none",borderRadius:8,padding:"5px 10px",fontSize:12,color:C.red,cursor:"pointer"}}>✕</button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <div style={{background:C.accentLight,border:`1px solid ${C.accent}33`,borderRadius:14,padding:"12px 14px",marginBottom:18,fontSize:13,color:C.accent,lineHeight:1.5}}>
        🔔 Уведомления приходят в Telegram автоматически перед каждой тренировкой, на которую вы записаны.
      </div>

      <Section title="Активные уведомления">
        {defaultNotif.active && !editingDefault && (
          <NotifCard
            icon="🌅"
            title={"Напоминание в день тренировки"}
            sub={"В " + defaultNotif.value + " в день тренировки"}
            onEdit={()=>{setEditDefaultTime(defaultNotif.value);setEditingDefault(true);}}
            onDelete={()=>setDefaultNotif(n=>({...n,active:false}))}
          />
        )}
        {editingDefault && (
          <div style={{background:C.card,border:`1.5px solid ${C.accent}`,borderRadius:14,padding:"16px",marginBottom:10,boxShadow:shadow}}>
            <div style={{fontWeight:700,fontSize:14,color:C.text,marginBottom:12}}>🌅 Редактировать напоминание</div>
            <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:6}}>Время · <span style={{color:C.accent}}>{editDefaultTime}</span></div>
            <TimePicker value={editDefaultTime} onChange={setEditDefaultTime}/>
            <div style={{display:"flex",gap:8,marginTop:4}}>
              <Btn full small variant="neutral" onClick={()=>setEditingDefault(false)}>Отмена</Btn>
              <Btn full small onClick={()=>{setDefaultNotif({active:true,type:"time",value:editDefaultTime});setEditingDefault(false);}}>Сохранить</Btn>
            </div>
          </div>
        )}
        {!defaultNotif.active && !editingDefault && (
          <div style={{background:C.yellowLight,border:`1px solid ${C.yellow}44`,borderRadius:12,padding:"10px 14px",marginBottom:10,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:13,color:C.yellow}}>⚠️ Стандартное напоминание удалено</span>
            <Btn small onClick={()=>setDefaultNotif({active:true,type:"time",value:"09:00"})}>Вернуть</Btn>
          </div>
        )}
        {custom && !editingCustom && (
          <NotifCard
            icon={custom.type==="hours"?"⏰":"🕐"}
            title={custom.type==="hours" ? "За " + custom.value + " " + hrWord(custom.value) + " до тренировки" : "В " + custom.value + " в день тренировки"}
            sub="Ваше дополнительное напоминание"
            onEdit={()=>{setAddType(custom.type);custom.type==="hours"?setAddHours(custom.value):setAddTime(custom.value);setEditingCustom(true);}}
            onDelete={()=>setCustom(null)}
          />
        )}
        {editingCustom && (
          <div style={{background:C.card,border:`1.5px solid ${C.accent}`,borderRadius:14,padding:"16px",marginBottom:10,boxShadow:shadow}}>
            <div style={{fontWeight:700,fontSize:14,color:C.text,marginBottom:12}}>✏️ Редактировать напоминание</div>
            <div style={{display:"flex",background:C.bg,borderRadius:10,padding:3,gap:3,marginBottom:14}}>
              {[{id:"hours",label:"За N часов до"},{id:"time",label:"В определённое время"}].map(t=>(
                <button key={t.id} onClick={()=>setAddType(t.id)} style={{flex:1,padding:"8px",borderRadius:8,border:"none",cursor:"pointer",background:addType===t.id?C.accent:"transparent",color:addType===t.id?"#fff":C.muted,fontWeight:addType===t.id?700:400,fontSize:12}}>{t.label}</button>
              ))}
            </div>
            {addType==="hours" && <><div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:8}}>За сколько часов?</div>
              <div style={{display:"flex",alignItems:"center",border:`1.5px solid ${C.border}`,borderRadius:12,background:"#fff",overflow:"hidden",marginBottom:14}}>
                <button onClick={()=>setAddHours(h=>Math.max(1,h-1))} style={{width:52,height:48,border:"none",borderRight:`1.5px solid ${C.border}`,background:addHours<=1?C.bg:C.accentLight,fontSize:22,color:addHours<=1?C.faint:C.accent,cursor:addHours<=1?"not-allowed":"pointer",fontWeight:700}}>−</button>
                <div style={{flex:1,textAlign:"center"}}><span style={{fontWeight:800,fontSize:22,color:C.text}}>{addHours}</span><span style={{fontSize:13,color:C.muted,marginLeft:6}}>{hrWord(addHours)}</span></div>
                <button onClick={()=>setAddHours(h=>Math.min(24,h+1))} style={{width:52,height:48,border:"none",borderLeft:`1.5px solid ${C.border}`,background:addHours>=24?C.bg:C.accentLight,fontSize:22,color:addHours>=24?C.faint:C.accent,cursor:addHours>=24?"not-allowed":"pointer",fontWeight:700}}>+</button>
              </div></>}
            {addType==="time" && <><div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:6}}>Время · <span style={{color:C.accent}}>{addTime}</span></div><TimePicker value={addTime} onChange={setAddTime}/></>}
            <div style={{display:"flex",gap:8,marginTop:4}}>
              <Btn full small variant="neutral" onClick={()=>setEditingCustom(false)}>Отмена</Btn>
              <Btn full small onClick={saveCustom}>Сохранить</Btn>
            </div>
          </div>
        )}
      </Section>

      {!custom && !adding && !editingCustom && (
        <Btn full variant="ghost" onClick={()=>setAdding(true)}>+ Добавить напоминание</Btn>
      )}

      {adding && (
        <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:16,padding:"16px",boxShadow:shadow}}>
          <div style={{fontWeight:700,fontSize:15,color:C.text,marginBottom:14}}>Новое напоминание</div>

          {/* Type selector */}
          <div style={{display:"flex",background:C.bg,borderRadius:10,padding:3,gap:3,marginBottom:16}}>
            {[{id:"hours",label:"За N часов до"},{id:"time",label:"В определённое время"}].map(t=>(
              <button key={t.id} onClick={()=>setAddType(t.id)} style={{flex:1,padding:"8px",borderRadius:8,border:"none",cursor:"pointer",background:addType===t.id?C.accent:"transparent",color:addType===t.id?"#fff":C.muted,fontWeight:addType===t.id?700:400,fontSize:12}}>
                {t.label}
              </button>
            ))}
          </div>

          {addType==="hours" && (
            <div>
              <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:8}}>За сколько часов до тренировки?</div>
              <div style={{display:"flex",alignItems:"center",border:`1.5px solid ${C.border}`,borderRadius:12,background:"#fff",overflow:"hidden",marginBottom:14}}>
                <button onClick={()=>setAddHours(h=>Math.max(1,h-1))} style={{width:52,height:48,border:"none",borderRight:`1.5px solid ${C.border}`,background:addHours<=1?C.bg:C.accentLight,fontSize:22,color:addHours<=1?C.faint:C.accent,cursor:addHours<=1?"not-allowed":"pointer",fontWeight:700}}>−</button>
                <div style={{flex:1,textAlign:"center"}}>
                  <span style={{fontWeight:800,fontSize:22,color:C.text}}>{addHours}</span>
                  <span style={{fontSize:13,color:C.muted,marginLeft:6}}>{addHours===1?"час":addHours<5?"часа":"часов"}</span>
                </div>
                <button onClick={()=>setAddHours(h=>Math.min(24,h+1))} style={{width:52,height:48,border:"none",borderLeft:`1.5px solid ${C.border}`,background:addHours>=24?C.bg:C.accentLight,fontSize:22,color:addHours>=24?C.faint:C.accent,cursor:addHours>=24?"not-allowed":"pointer",fontWeight:700}}>+</button>
              </div>
              <div style={{background:C.accentLight,borderRadius:10,padding:"10px 14px",fontSize:12,color:C.accent,marginBottom:14}}>
                Например, если тренировка в 10:00 — уведомление придёт в {String(10-addHours).padStart(2,"0")}:00
              </div>
            </div>
          )}

          {addType==="time" && (
            <div style={{marginBottom:14}}>
              <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:8}}>Время уведомления · <span style={{color:C.accent}}>{addTime}</span></div>
              <TimePicker value={addTime} onChange={setAddTime}/>
            </div>
          )}

          <div style={{display:"flex",gap:8}}>
            <Btn full variant="neutral" onClick={()=>setAdding(false)}>Отмена</Btn>
            <Btn full onClick={saveCustom}>Сохранить</Btn>
          </div>
        </div>
      )}

      <div style={{marginTop:24,borderTop:`1px solid ${C.border}`,paddingTop:18}}>
        <div style={{fontSize:11,fontWeight:700,color:C.faint,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:12}}>Что вам приходит автоматически</div>
        {[
          {icon:"📅", text:"Подтверждение записи на тренировку (при самозаписи или добавлении тренером)"},
          {icon:"❌", text:"Уведомление об отмене тренировки"},
          {icon:"✏️", text:"Уведомление об изменении деталей тренировки"},
        ].map((n,i)=>(
          <div key={i} style={{display:"flex",gap:10,alignItems:"flex-start",marginBottom:10}}>
            <span style={{fontSize:16,flexShrink:0}}>{n.icon}</span>
            <span style={{fontSize:13,color:C.muted,lineHeight:1.5}}>{n.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function PlayerCalendar({sessions, locations, bookings, setBookings, token, API}) {
  const [bookToast,setBookToast] = useState(null);
  const [booking, setBooking]   = useState(null); // id тренировки в процессе записи
  const locName = id => locations.find(l=>l.id===id)?.name||"";

  // Показываем свободные тренировки на которые не записан
  const visible = sessions.filter(s => (s.free_slot||s.free) && !bookings.includes(s.id) && parseInt(s.booked_count||0) < parseInt(s.max_players||s.max||0));

  const doBook = async (s) => {
    setBooking(s.id);
    try {
      const r = await fetch(API+'/bookings', {
        method: 'POST',
        headers: {'Authorization':'Bearer '+token, 'Content-Type':'application/json'},
        body: JSON.stringify({session_id: s.id})
      });
      const data = await r.json();
      if (r.ok) {
        setBookings(b=>[...b, s.id]);
        setBookToast("📅 Вы записаны: " + formatDate(s.date) + " · " + formatTime(s.time) + " · " + (s.price?s.price+"₽":"Бесплатно"));
      } else {
        setBookToast("⚠️ " + (data.error||"Ошибка записи"));
      }
    } catch(e) { setBookToast("⚠️ Ошибка соединения"); }
    setBooking(null);
  };

  return (
    <>
    <div>
      {visible.length===0&&(
        <div style={{textAlign:"center",padding:"40px 20px",color:C.muted}}>
          <div style={{fontSize:36,marginBottom:10}}>📅</div>
          <div style={{fontWeight:700,fontSize:15,color:C.text,marginBottom:6}}>Нет доступных тренировок</div>
          <div style={{fontSize:13}}>Тренер пока не добавил открытые тренировки</div>
        </div>
      )}
      {visible.map(s=>{
        const booked = parseInt(s.booked_count||s.booked||0);
        const max = s.max_players||s.max||0;
        const full = max>0 && booked>=max;
        return (
          <Card key={s.id}>
            <div style={{display:"flex",justifyContent:"space-between"}}>
              <div>
                <div style={{fontSize:12,color:C.muted,fontWeight:600}}>{formatDate(s.date)}</div>
                <div style={{fontWeight:800,fontSize:22,color:C.text,marginTop:1}}>{formatTime(s.time)}</div>
                <div style={{fontSize:12,color:C.muted,marginTop:5}}>⏱ {s.duration} мин{locName(s.location_id||s.locId)?` · 📍 ${locName(s.location_id||s.locId).split(",")[0]}`:""}</div>
                <div style={{fontSize:12,color:C.muted,marginTop:2}}>👨‍🏫 {s.coach_name||s.coach}</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontWeight:800,fontSize:17,color:C.accent}}>{s.price?`${s.price}₽`:"Бесплатно"}</div>
                <div style={{fontSize:12,color:full?C.red:C.muted,marginTop:5}}>{full?"Мест нет":`${max-booked} из ${max}`}</div>
              </div>
            </div>
            <div style={{display:"flex",gap:6,marginTop:10,flexWrap:"wrap"}}>
              <Chip label={s.level}/>
              {(s.repeat_weekly||s.repeat)&&<Tag bg={C.yellowDim} color={C.yellow}>↻ Еженедельно</Tag>}
            </div>
            {!full&&(
              <Btn full onClick={()=>doBook(s)} disabled={booking===s.id}
                variant="primary" style={{marginTop:12}}>
                {booking===s.id ? "Записываемся..." : "✓ Записаться"}
              </Btn>
            )}
            {full&&(
              <button disabled style={{width:"100%",marginTop:12,background:C.bg,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"11px",fontWeight:700,fontSize:14,color:C.muted}}>
                Мест нет
              </button>
            )}
          </Card>
        );
      })}
    </div>
    {bookToast&&<Toast message={bookToast} onDone={()=>setBookToast(null)}/>}
    </>
  );
}


function PlayerBookings({sessions, locations, bookings, setBookings, myBookings, setMyBookings, token, API}) {
  const today = new Date(); today.setHours(0,0,0,0);
  const isExpired = s => {
    const iso = (s.date||"").slice(0,10);
    if(!iso) return false;
    const [y,mo,d] = iso.split("-").map(Number);
    const sessionDay = new Date(y,mo-1,d);
    const nextDay = new Date(sessionDay); nextDay.setDate(sessionDay.getDate()+1);
    return nextDay <= today;
  };

  // Используем myBookings (полные данные из API) если есть, иначе фильтруем sessions
  const allMine = myBookings.length > 0 ? myBookings : sessions.filter(s=>bookings.includes(s.id));
  const active = allMine.filter(s=>!isExpired(s));
  const archived = allMine.filter(s=>isExpired(s)).sort((a,b)=>(b.date||"").localeCompare(a.date||""));
  const locName = id => locations.find(l=>l.id===id)?.name||"";
  const [toast,setToast] = useState(null);
  const [showArchive,setShowArchive] = useState(false);

  const cancel = async (s) => {
    await fetch(API+'/bookings/'+s.id, {
      method: 'DELETE',
      headers: {'Authorization':'Bearer '+token}
    }).catch(()=>{});
    setBookings(b=>b.filter(id=>id!==s.session_id));
    setMyBookings(prev=>prev.filter(b=>b.id!==s.id));
    setToast("ℹ️ Запись отменена · " + formatDate(s.date) + " " + formatTime(s.time));
  };

  const BookingCard = ({s, past}) => (
    <Card key={s.id} style={{opacity:past?0.6:1}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
        <div>
          <div style={{color:past?C.muted:C.green,fontWeight:700,fontSize:12,marginBottom:4}}>{past?"✓ Прошедшая":"✓ Записан"}</div>
          <div style={{fontWeight:800,fontSize:18,color:C.text}}>{formatDate(s.date)} · {formatTime(s.time)}</div>
          <div style={{fontSize:12,color:C.muted,marginTop:5}}>⏱ {s.duration} мин · 📍 {(s.location_name||locName(s.location_id||s.locId)||"").split(",")[0]}</div>
          <div style={{fontSize:12,color:C.muted,marginTop:2}}>👨‍🏫 {s.coach_name||s.coach}</div>
        </div>
        <div style={{fontWeight:800,fontSize:17,color:C.accent}}>{s.price?`${s.price}₽`:"Бесплатно"}</div>
      </div>
      {!past&&<Btn full variant="danger" style={{marginTop:14}} onClick={()=>cancel(s)}>Отменить запись</Btn>}
    </Card>
  );

  return (
    <div>
      <div style={{fontSize:11,fontWeight:700,color:C.faint,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:14}}>Мои записи ({active.length})</div>
      {active.length===0&&(
        <div style={{textAlign:"center",padding:"40px 20px",color:C.muted}}>
          <div style={{fontSize:36,marginBottom:10}}>📋</div>
          <div style={{fontWeight:700,fontSize:15,color:C.text,marginBottom:6}}>Нет активных записей</div>
          <div style={{fontSize:13}}>Перейдите в «Открытые тренировки», чтобы записаться</div>
        </div>
      )}
      {active.map(s=><BookingCard key={s.id} s={s} past={false}/>)}

      {archived.length>0&&(
        <div style={{marginTop:16}}>
          <button onClick={()=>setShowArchive(!showArchive)} style={{width:"100%",background:C.bg,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",color:C.muted,fontSize:14,fontWeight:600}}>
            <span>🗄 Архив тренировок ({archived.length})</span>
            <span style={{fontSize:12}}>{showArchive?"▲":"▼"}</span>
          </button>
          {showArchive&&(
            <div style={{marginTop:8}}>
              {archived.map(s=><BookingCard key={s.id} s={s} past={true}/>)}
            </div>
          )}
        </div>
      )}
      {toast&&<Toast message={toast} onDone={()=>setToast(null)}/>}
    </div>
  );
}


// ── ADMIN USERS ────────────────────────────────────────────────────────────────
function AdminUsers({coaches, players}) {
  // Build unified user list from coaches + players
  const [banned, setBanned]       = useState(new Set());
  const [showBanned, setShowBanned] = useState(false);

  const allUsers = [
    ...coaches.map(c=>({id:`c${c.id}`,name:c.name,username:c.username,role:"Тренер",roleColor:C.purple,roleBg:C.purpleDim,since:c.since})),
    ...players.map(p=>({id:`p${p.id}`,name:p.name,username:p.username,role:"Участник",roleColor:C.accent,roleBg:C.accentDim,since:p.since})),
  ];

  const active = allUsers.filter(u=>!banned.has(u.id));
  const bannedList = allUsers.filter(u=>banned.has(u.id));

  const ban   = id => setBanned(prev=>new Set([...prev,id]));
  const unban = id => setBanned(prev=>{const n=new Set(prev);n.delete(id);return n;});

  const UserRow = ({u, isBanned}) => (
    <div style={{background:isBanned?C.card2:C.card,border:`1px solid ${isBanned?C.border:C.border}`,borderRadius:14,padding:"12px 14px",marginBottom:10,display:"flex",justifyContent:"space-between",alignItems:"center",opacity:isBanned?0.7:1}}>
      <div style={{display:"flex",alignItems:"center",gap:12}}>
        <div style={{width:40,height:40,borderRadius:"50%",background:isBanned?C.redDim:u.roleBg,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:16,color:isBanned?C.red:u.roleColor,flexShrink:0}}>
          {u.name[0]}
        </div>
        <div>
          <div style={{fontWeight:700,fontSize:14,color:isBanned?C.muted:C.text}}>{u.name}</div>
          <div style={{fontSize:12,color:C.faint,marginTop:2,display:"flex",alignItems:"center",gap:6}}>
            <span>{u.username}</span>
            <span style={{background:isBanned?C.redDim:u.roleBg,color:isBanned?C.red:u.roleColor,padding:"1px 8px",borderRadius:20,fontSize:10,fontWeight:700}}>{isBanned?"Заблокирован":u.role}</span>
          </div>
        </div>
      </div>
      {isBanned ? (
        <button onClick={()=>unban(u.id)} style={{background:C.greenDim,border:"none",borderRadius:10,padding:"7px 14px",fontSize:12,fontWeight:700,color:C.green,cursor:"pointer",whiteSpace:"nowrap"}}>
          ✓ Разблокировать
        </button>
      ) : (
        <button onClick={()=>ban(u.id)} style={{background:C.redDim,border:"none",borderRadius:10,padding:"7px 14px",fontSize:12,fontWeight:700,color:C.red,cursor:"pointer",whiteSpace:"nowrap"}}>
          🚫 Заблокировать
        </button>
      )}
    </div>
  );

  return (
    <div>
      <div style={{fontSize:11,fontWeight:700,color:C.faint,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:14}}>
        Все пользователи ({active.length})
      </div>

      {active.map(u=><UserRow key={u.id} u={u} isBanned={false}/>)}

      {bannedList.length>0 && (
        <div style={{marginTop:8}}>
          <button onClick={()=>setShowBanned(!showBanned)} style={{width:"100%",background:C.redLight,border:`1px solid ${C.red}33`,borderRadius:12,padding:"11px 16px",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:showBanned?10:0}}>
            <span style={{fontSize:13,fontWeight:700,color:C.red}}>🚫 Заблокированные ({bannedList.length})</span>
            <span style={{fontSize:16,color:C.red,transition:"transform 0.2s",display:"inline-block",transform:showBanned?"rotate(180deg)":"rotate(0deg)"}}>▾</span>
          </button>
          {showBanned && bannedList.map(u=><UserRow key={u.id} u={u} isBanned={true}/>)}
        </div>
      )}
    </div>
  );
}


// ── HELPERS ────────────────────────────────────────────────────────────────────
const TODAY_ISO = "2026-05-28";
const TODAY_MS  = new Date(TODAY_ISO).getTime();

const daysUntil = isoDate => {
  if(!isoDate) return null;
  return Math.ceil((new Date(isoDate).getTime() - TODAY_MS) / 86400000);
};

const payStatus = isoDate => {
  const d = daysUntil(isoDate);
  if(d===null) return {label:"Не настроено", color:C.faint, bg:"#f1f5f9"};
  if(d < 0)   return {label:"Просрочено",   color:C.red,   bg:C.redLight};
  if(d <= 3)  return {label:"Скоро · "+d+"д", color:C.yellow, bg:C.yellowLight};
  return       {label:"Оплачено · "+d+"д", color:C.green,  bg:C.greenLight};
};

// Trial helpers
const trialDaysLeft = c => {
  const firstDate = c.first_session_date || c.firstSession;
  if(!firstDate) return null;
  const start = new Date(firstDate);
  const trialDays = c.trial_days || c.trialDays || 21;
  const trialEnd = new Date(start);
  trialEnd.setDate(start.getDate() + trialDays);
  const today = new Date(); today.setHours(0,0,0,0);
  const daysLeft = Math.ceil((trialEnd - today) / 86400000);
  return daysLeft;
};

const trialStatus = c => {
  const d = trialDaysLeft(c);
  if(d===null) return {label:"Тест не начат",   color:C.faint,   bg:"#f1f5f9", pct:0};
  if(d<=0)     return {label:"Тест истёк",      color:C.red,     bg:C.redLight, pct:100};
  if(d<=7)     return {label:"Осталось "+d+"д", color:C.yellow,  bg:C.yellowLight, pct:Math.round((1-d/21)*100)};
  return        {label:"Осталось "+d+"д",       color:C.green,   bg:C.greenLight, pct:Math.round((1-d/21)*100)};
};

// ── ADMIN PAYMENTS ─────────────────────────────────────────────────────────────
function AdminPayments({coaches}) {
  const [data, setData]         = useState([]);
  const [stats, setStats]       = useState(null);
  const [loading, setLoading]   = useState(true);
  const [expanded, setExpanded] = useState({});
  const [showStats, setShowStats] = useState(false);
  const [payForm, setPayForm]   = useState(null); // coach_id
  const [payAmt, setPayAmt]     = useState("");
  const [payDate, setPayDate]   = useState(new Date().toISOString().slice(0,10));
  const [feeEdit, setFeeEdit]   = useState(null);
  const [feeVal, setFeeVal]     = useState("");
  const [saving, setSaving]     = useState(false);

  const load = () => {
    fetch('https://mycoachspace.ru/api/admin/coach-payments')
      .then(r=>r.json()).then(d=>{ if(Array.isArray(d)) setData(d); setLoading(false); }).catch(()=>setLoading(false));
    fetch('https://mycoachspace.ru/api/admin/coach-payments/stats')
      .then(r=>r.json()).then(d=>{ if(d) setStats(d); }).catch(()=>{});
  };

  useEffect(()=>{ load(); },[]);

  const addPayment = async (coachId) => {
    if(!payAmt) return;
    setSaving(true);
    await fetch('https://mycoachspace.ru/api/admin/coach-payments', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({coach_id:coachId, amount:Number(payAmt), paid_date:payDate})
    }).catch(()=>{});
    setSaving(false); setPayForm(null); setPayAmt(""); load();
  };

  const saveFee = async (coachId) => {
    await fetch(`https://mycoachspace.ru/api/admin/coaches/${coachId}/fee`, {
      method:'PATCH', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({monthly_fee: Number(feeVal)})
    }).catch(()=>{});
    setData(d=>d.map(c=>c.coach_id===coachId?{...c,monthly_fee:Number(feeVal)}:c));
    setFeeEdit(null);
  };

  const deletePayment = async (payId, coachId) => {
    await fetch(`https://mycoachspace.ru/api/admin/coach-payments/${payId}`, {method:'DELETE'}).catch(()=>{});
    load();
  };

  const trialInfo = (c) => {
    if(!c.first_session_date) return {inTrial:true, label:"Тренировок ещё не было", daysLeft:null};
    const start = new Date(c.first_session_date);
    const trialEnd = new Date(start); trialEnd.setDate(start.getDate()+(c.trial_days||21));
    const today = new Date(); today.setHours(0,0,0,0);
    const daysUsed = Math.floor((today-start)/86400000);
    const daysLeft = Math.ceil((trialEnd-today)/86400000);
    if(daysLeft>0) return {inTrial:true, label:`Тест: ${daysUsed} из ${c.trial_days||21} дн`, daysLeft};
    return {inTrial:false, label:"Активный"};
  };

  const nextDateStatus = (nextDate) => {
    if(!nextDate) return null;
    const d = new Date(nextDate); const today = new Date(); today.setHours(0,0,0,0);
    const diff = Math.ceil((d-today)/86400000);
    if(diff<0) return {label:`Просрочен на ${-diff} дн`, color:C.red, bg:"#FEF2F2", border:"#FECACA"};
    if(diff===0) return {label:"Сегодня!", color:C.red, bg:"#FEF2F2", border:"#FECACA"};
    if(diff<=3) return {label:`Через ${diff} дн`, color:C.yellow, bg:"#FFFBEB", border:"#FDE68A"};
    return {label:formatDate(nextDate), color:C.green, bg:"#F0FDF4", border:"#BBF7D0"};
  };

  if(loading) return <div style={{textAlign:"center",padding:40,color:C.muted}}>Загрузка...</div>;

  return (
    <div>
      {/* Статистика */}
      <button onClick={()=>setShowStats(!showStats)} style={{width:"100%",background:showStats?C.accentLight:"#fff",border:`1.5px solid ${showStats?C.accent:C.border}`,borderRadius:12,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",marginBottom:12,fontSize:14,fontWeight:600,color:showStats?C.accent:C.text}}>
        <span>📊 Общая статистика</span>
        <span>{showStats?"▲":"▼"}</span>
      </button>
      {showStats&&stats&&(
        <div style={{marginBottom:12}}>
          {[
            {l:`Оплачено в ${stats.month_label}`, v:`${stats.paid_this_month.toLocaleString()}₽`, c:C.green},
            {l:`Планируется в ${stats.month_label}`, v:`${stats.planned_this_month.toLocaleString()}₽`, c:C.accent},
            {l:"Оплачено всего", v:`${stats.paid_total.toLocaleString()}₽`, c:C.text},
          ].map(x=>(
            <div key={x.l} style={{background:"#fff",border:`1px solid ${C.border}`,borderRadius:12,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
              <div style={{fontSize:13,color:C.muted}}>{x.l}</div>
              <div style={{fontWeight:800,fontSize:18,color:x.c}}>{x.v}</div>
            </div>
          ))}
        </div>
      )}

      <div style={{fontSize:11,color:C.faint,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8}}>Тренеры ({data.length})</div>

      {data.map(c=>{
        const trial = trialInfo(c);
        const totalPaid = parseInt(c.total_paid||0);
        // Считаем сколько начислено (месяцев после тестового периода * тариф)
        let charged = 0;
        if(!trial.inTrial && c.first_session_date) {
          const start = new Date(c.first_session_date);
          start.setDate(start.getDate()+(c.trial_days||21));
          const today = new Date();
          const months = Math.max(0, Math.floor((today-start)/2592000000));
          charged = months * (c.monthly_fee||500);
        }
        const balance = totalPaid - charged;
        const balanceColor = balance>0?C.green:balance<0?C.red:C.muted;
        const balanceStr = balance>0?`+${balance.toLocaleString()}₽`:balance<0?`${balance.toLocaleString()}₽`:"0₽";
        const ns = nextDateStatus(c.next_date);
        const isOpen = expanded[c.coach_id];

        return (
          <Card key={c.coach_id} style={{marginBottom:10}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <div style={{fontWeight:700,fontSize:14,color:C.text}}>{c.name}</div>
                <div style={{fontSize:12,color:C.muted,marginTop:2,display:"flex",alignItems:"center",gap:6}}>
                  <span>{c.monthly_fee||500}₽/мес</span>
                  <span style={{background:trial.inTrial?C.yellowDim:C.greenDim,color:trial.inTrial?C.yellow:C.green,fontSize:10,fontWeight:600,padding:"1px 7px",borderRadius:20}}>
                    {trial.inTrial?"⏳ "+trial.label:"✓ Активный"}
                  </span>
                </div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <div style={{fontWeight:800,fontSize:16,color:balanceColor}}>{balanceStr}</div>
                <button onClick={()=>setExpanded(e=>({...e,[c.coach_id]:!isOpen}))}
                  style={{background:isOpen?C.accentLight:"#f4f6fb",border:`1px solid ${isOpen?C.accent:C.border}`,borderRadius:8,padding:"5px 12px",fontSize:12,color:isOpen?C.accent:C.muted,cursor:"pointer",whiteSpace:"nowrap"}}>
                  {isOpen?"Свернуть":"Подробнее"}
                </button>
              </div>
            </div>

            {isOpen&&(<>
              <div style={{height:12}}/>
              {ns&&(
                <div style={{background:ns.bg,border:`1px solid ${ns.border}`,borderRadius:10,padding:"8px 12px",marginBottom:10,display:"flex",justifyContent:"space-between",fontSize:12}}>
                  <span style={{color:ns.color}}>📅 Следующий платёж</span>
                  <span style={{color:ns.color,fontWeight:700}}>{ns.label}</span>
                </div>
              )}
              {!c.first_session_date&&(
                <div style={{background:C.yellowDim,borderRadius:10,padding:"8px 12px",marginBottom:10,fontSize:12,color:C.yellow}}>
                  ⏳ Тренировок ещё не было — тестовый период не начат
                </div>
              )}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
                {[{l:"Долг/переплата",v:balanceStr,c:balanceColor},{l:"Оплачено всего",v:`${totalPaid.toLocaleString()}₽`,c:C.green}].map(x=>(
                  <div key={x.l} style={{background:C.bg,borderRadius:10,padding:"10px 12px",textAlign:"center"}}>
                    <div style={{fontWeight:700,fontSize:15,color:x.c}}>{x.v}</div>
                    <div style={{fontSize:11,color:C.faint,marginTop:2}}>{x.l}</div>
                  </div>
                ))}
              </div>

              {/* Тариф */}
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                <span style={{fontSize:13,color:C.muted,flexShrink:0}}>Тариф:</span>
                {feeEdit===c.coach_id?(
                  <>
                    <input type="number" value={feeVal} onChange={e=>setFeeVal(e.target.value)}
                      style={{width:80,border:`1.5px solid ${C.accent}`,borderRadius:8,padding:"5px 8px",fontSize:14,fontWeight:600,textAlign:"center",outline:"none"}}/>
                    <span style={{fontSize:13,color:C.muted}}>₽/мес</span>
                    <Btn small onClick={()=>saveFee(c.coach_id)}>Сохранить</Btn>
                    <Btn small variant="neutral" onClick={()=>setFeeEdit(null)}>✕</Btn>
                  </>
                ):(
                  <>
                    <span style={{fontWeight:700,fontSize:14,color:C.text}}>{c.monthly_fee||500}₽/мес</span>
                    <Btn small variant="ghost" onClick={()=>{setFeeEdit(c.coach_id);setFeeVal(String(c.monthly_fee||500));}}>Изменить</Btn>
                  </>
                )}
              </div>

              {/* Форма оплаты */}
              {payForm===c.coach_id?(
                <div style={{background:C.bg,borderRadius:10,padding:12,marginBottom:10}}>
                  <div style={{fontSize:13,fontWeight:600,color:C.text,marginBottom:8}}>Отметить оплату</div>
                  <Input label="Сумма (₽)" type="number" value={payAmt} onChange={e=>setPayAmt(e.target.value)} placeholder={String(c.monthly_fee||500)}/>
                  <div style={{marginBottom:10}}>
                    <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:5}}>Дата оплаты</div>
                    <input type="date" value={payDate} onChange={e=>setPayDate(e.target.value)}
                      style={{width:"100%",border:`1.5px solid ${C.border}`,borderRadius:10,padding:"9px 12px",fontSize:14,color:C.text,outline:"none",boxSizing:"border-box"}}/>
                  </div>
                  <div style={{display:"flex",gap:8}}>
                    <Btn full small variant="neutral" onClick={()=>setPayForm(null)}>Отмена</Btn>
                    <Btn full small onClick={()=>addPayment(c.coach_id)} disabled={saving}>{saving?"...":"Сохранить"}</Btn>
                  </div>
                </div>
              ):(
                <Btn full onClick={()=>{setPayForm(c.coach_id);setPayAmt(String(c.monthly_fee||500));}} style={{marginBottom:10}}>+ Отметить оплату</Btn>
              )}

              {/* История */}
              {c.history&&c.history.length>0&&(<>
                <div style={{fontSize:11,color:C.faint,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:6}}>История</div>
                {c.history.map(h=>(
                  <div key={h.id} style={{display:"flex",alignItems:"center",gap:8,padding:"8px 0",borderBottom:`1px solid ${C.border}`}}>
                    <div style={{flex:1}}>
                      <div style={{fontSize:13,fontWeight:600,color:C.text}}>{parseInt(h.amount).toLocaleString()}₽</div>
                      <div style={{fontSize:11,color:C.muted}}>{formatDate(h.paid_date)} → след. {formatDate(h.next_date)}</div>
                    </div>
                    <button onClick={()=>deletePayment(h.id,c.coach_id)} style={{background:"none",border:"none",color:C.faint,cursor:"pointer",fontSize:16,padding:"0 4px"}}>✕</button>
                  </div>
                ))}
              </>)}
            </>)}
          </Card>
        );
      })}
    </div>
  );
}

function AdminSettings({trialDays, setTrialDays, coaches, players, onBroadcast}) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(String(trialDays));
  const [showBroadcast, setShowBroadcast] = useState(false);

  return (
    <div>
      <Section title="Рассылка">
        <Card>
          <div style={{fontSize:13,color:C.muted,marginBottom:14,lineHeight:1.6}}>
            Отправить сообщение всем тренерам или участникам платформы.
          </div>
          <Btn full onClick={()=>setShowBroadcast(true)}>📢 Рассылка</Btn>
        </Card>
      </Section>
      {showBroadcast&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",zIndex:300,display:"flex",alignItems:"flex-end",borderRadius:16,overflow:"hidden"}}>
          <div style={{background:"#fff",width:"100%",borderRadius:"16px 16px 0 0",padding:"16px",maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <div style={{fontWeight:700,fontSize:16,color:C.text}}>Рассылка</div>
              <button onClick={()=>setShowBroadcast(false)} style={{background:C.bg,border:"none",borderRadius:"50%",width:28,height:28,cursor:"pointer",fontSize:14,color:C.muted}}>✕</button>
            </div>
            <AdminBroadcast coaches={coaches} players={players}/>
          </div>
        </div>
      )}
      <Section title="Тестовый период">
        <Card>
          <div style={{fontSize:13,color:C.muted,marginBottom:14,lineHeight:1.6}}>
            Тестовый период отсчитывается от первой состоявшейся тренировки каждого тренера. По истечении тестового периода тренер переходит на платный тариф.
          </div>
          {editing ? (
            <div>
              <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:8}}>Длительность тестового периода</div>
              <div style={{display:"flex",alignItems:"center",border:`1.5px solid ${C.border}`,borderRadius:12,background:"#fff",overflow:"hidden",marginBottom:14}}>
                <button onClick={()=>setVal(v=>String(Math.max(1,Number(v)-1)))} style={{width:52,height:48,border:"none",borderRight:`1.5px solid ${C.border}`,background:Number(val)<=1?C.bg:C.accentLight,fontSize:22,color:Number(val)<=1?C.faint:C.accent,cursor:Number(val)<=1?"not-allowed":"pointer",fontWeight:700,flexShrink:0}}>−</button>
                <div style={{flex:1,textAlign:"center"}}>
                  <span style={{fontWeight:800,fontSize:22,color:C.text}}>{val}</span>
                  <span style={{fontSize:13,color:C.muted,marginLeft:6}}>дней</span>
                </div>
                <button onClick={()=>setVal(v=>String(Number(v)+1))} style={{width:52,height:48,border:"none",borderLeft:`1.5px solid ${C.border}`,background:C.accentLight,fontSize:22,color:C.accent,cursor:"pointer",fontWeight:700,flexShrink:0}}>+</button>
              </div>
              <div style={{display:"flex",gap:8}}>
                <Btn full variant="neutral" onClick={()=>{setEditing(false);setVal(String(trialDays));}}>Отмена</Btn>
                <Btn full onClick={()=>{setTrialDays(Number(val));setEditing(false);}}>Сохранить</Btn>
              </div>
            </div>
          ) : (
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:C.bg,borderRadius:12,padding:"14px 16px"}}>
              <div>
                <div style={{fontSize:11,color:C.faint}}>Текущий тестовый период</div>
                <div style={{fontWeight:800,fontSize:28,color:C.accent,marginTop:4}}>{trialDays} <span style={{fontSize:14,fontWeight:400,color:C.muted}}>дней</span></div>
              </div>
              <Btn small variant="ghost" onClick={()=>{setVal(String(trialDays));setEditing(true);}}>✏️ Изменить</Btn>
            </div>
          )}
        </Card>
      </Section>
    </div>
  );
}

// ── ADMIN BROADCAST ────────────────────────────────────────────────────────────
function AdminBroadcast({coaches, players}) {
  const [audience, setAudience] = useState("coaches"); // coaches | players | all
  const [text, setText]   = useState("");
  const [sent, setSent]   = useState(false);

  const counts = {
    coaches: coaches.filter(c=>c.active).length,
    players: players.length,
    all:     coaches.filter(c=>c.active).length + players.length,
  };
  const labels = {coaches:"Тренеры",players:"Участники",all:"Все"};

  const handleSend = () => { if(text.trim()) setSent(true); };
  const reset = () => { setSent(false); setText(""); };

  return (
    <div>
      {sent ? (
        <div style={{textAlign:"center",padding:"40px 20px"}}>
          <div style={{fontSize:52,marginBottom:16}}>✅</div>
          <div style={{fontWeight:800,fontSize:20,color:C.text,marginBottom:8}}>Рассылка отправлена!</div>
          <div style={{fontSize:14,color:C.muted,marginBottom:24}}>
            Сообщение получили <strong>{counts[audience]}</strong> {audience==="coaches"?"тренеров":audience==="players"?"участников":"пользователей"}
          </div>
          <Btn full onClick={reset}>Новая рассылка</Btn>
        </div>
      ) : (
        <div>
          <div style={{fontSize:13,color:C.muted,marginBottom:16,lineHeight:1.5}}>
            Сообщение придёт в Telegram каждому получателю выбранной группы.
          </div>

          <Section title="Кому отправить">
            <div style={{display:"flex",gap:8}}>
              {["coaches","players","all"].map(a=>(
                <button key={a} onClick={()=>setAudience(a)} style={{flex:1,padding:"12px 8px",borderRadius:12,border:`1.5px solid ${audience===a?C.accent:C.border}`,background:audience===a?C.accentLight:"#fff",cursor:"pointer",transition:"all 0.15s"}}>
                  <div style={{fontWeight:700,fontSize:14,color:audience===a?C.accent:C.text}}>{labels[a]}</div>
                  <div style={{fontSize:12,color:audience===a?C.accent:C.muted,marginTop:3}}>{counts[a]} чел.</div>
                </button>
              ))}
            </div>
          </Section>

          <Section title="Текст сообщения">
            <textarea value={text} onChange={e=>setText(e.target.value)}
              placeholder="Введите текст сообщения для рассылки..."
              style={{width:"100%",border:`1.5px solid ${text?C.accent:C.border}`,borderRadius:12,padding:"12px 14px",fontSize:14,color:C.text,background:"#fff",boxSizing:"border-box",minHeight:130,resize:"none",fontFamily:"inherit",outline:"none"}}
              onFocus={e=>e.target.style.borderColor=C.accent}
              onBlur={e=>e.target.style.borderColor=text?C.accent:C.border}
            />
            <div style={{display:"flex",justifyContent:"space-between",marginTop:6,marginBottom:16}}>
              <span style={{fontSize:12,color:C.faint}}>{text.length} символов</span>
              {text.trim()&&<span style={{fontSize:12,color:C.accent}}>✓ Готово к отправке</span>}
            </div>
            {text.trim()&&(
              <div style={{background:C.accentLight,border:`1px solid ${C.accent}33`,borderRadius:12,padding:"10px 14px",marginBottom:14,fontSize:13,color:C.accent}}>
                📲 Получат уведомление: <strong>{counts[audience]} {audience==="coaches"?"тренеров":audience==="players"?"участников":"пользователей"}</strong>
              </div>
            )}
            <Btn full onClick={handleSend} disabled={!text.trim()}>
              Отправить {counts[audience]} {audience==="coaches"?"тренерам":audience==="players"?"участникам":"пользователям"}
            </Btn>
          </Section>
        </div>
      )}
    </div>
  );
}

// ── SEARCH ─────────────────────────────────────────────────────────────────────
function SearchOverlay({coaches, players, sessions, locations, role, onClose}) {
  const [q, setQ] = useState("");
  const locName = id => locations.find(l=>l.id===id)?.name||"";
  const lq = q.toLowerCase().trim();

  const matchCoaches  = !lq ? [] : coaches.filter(c=>c.name.toLowerCase().includes(lq)||c.username.toLowerCase().includes(lq));
  const matchPlayers  = !lq ? [] : players.filter(p=>p.name.toLowerCase().includes(lq)||p.username.toLowerCase().includes(lq));
  const matchSessions = !lq ? [] : sessions.filter(s=>
    s.date.toLowerCase().includes(lq)||s.time.includes(lq)||
    s.level.toLowerCase().includes(lq)||locName(s.locId).toLowerCase().includes(lq)||
    s.coach.toLowerCase().includes(lq)
  );

  const total = matchCoaches.length + matchPlayers.length + matchSessions.length;

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:500,display:"flex",flexDirection:"column"}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#fff",padding:"16px 20px",borderBottom:`1px solid ${C.border}`}}>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <span style={{fontSize:18,color:C.muted}}>🔍</span>
          <input autoFocus value={q} onChange={e=>setQ(e.target.value)}
            placeholder="Поиск по имени, дате, локации, уровню..."
            style={{flex:1,border:"none",outline:"none",fontSize:16,color:C.text,background:"transparent"}}
          />
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:18,color:C.muted,cursor:"pointer",padding:"4px"}}>✕</button>
        </div>
      </div>
      <div onClick={e=>e.stopPropagation()} style={{flex:1,overflowY:"auto",background:C.bg,padding:"12px 20px"}}>
        {!lq && (
          <div style={{textAlign:"center",padding:"40px 20px",color:C.muted}}>
            <div style={{fontSize:36,marginBottom:10}}>🔍</div>
            <div style={{fontSize:14}}>Начните вводить запрос</div>
          </div>
        )}
        {lq && total===0 && (
          <div style={{textAlign:"center",padding:"40px 20px",color:C.muted}}>
            <div style={{fontSize:36,marginBottom:10}}>🤷</div>
            <div style={{fontWeight:600,fontSize:15,color:C.text,marginBottom:6}}>Ничего не найдено</div>
            <div style={{fontSize:13}}>Попробуйте другой запрос</div>
          </div>
        )}

        {matchSessions.length>0 && (
          <div style={{marginBottom:16}}>
            <div style={{fontSize:11,fontWeight:700,color:C.faint,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:10}}>Тренировки ({matchSessions.length})</div>
            {matchSessions.map(s=>(
              <div key={s.id} style={{background:"#fff",borderRadius:14,border:`1px solid ${C.border}`,padding:"12px 14px",marginBottom:8,boxShadow:shadow}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:14,color:C.text}}>{formatDate(s.date)} · {formatTime(s.time)}</div>
                    <div style={{fontSize:12,color:C.muted,marginTop:3}}>📍 {locName(s.locId)} · 👨‍🏫 {s.coach}</div>
                  </div>
                  <Chip label={s.level} small/>
                </div>
              </div>
            ))}
          </div>
        )}

        {matchPlayers.length>0 && (
          <div style={{marginBottom:16}}>
            <div style={{fontSize:11,fontWeight:700,color:C.faint,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:10}}>Участники ({matchPlayers.length})</div>
            {matchPlayers.map(p=>(
              <div key={p.id} style={{background:"#fff",borderRadius:14,border:`1px solid ${C.border}`,padding:"12px 14px",marginBottom:8,boxShadow:shadow,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{width:36,height:36,borderRadius:"50%",background:C.accentDim,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:C.accent}}>{p.name[0]}</div>
                  <div>
                    <div style={{fontWeight:700,fontSize:14,color:C.text}}>{p.name}</div>
                    <div style={{fontSize:12,color:C.muted}}>{p.username}</div>
                  </div>
                </div>
                <Chip label={p.level} small/>
              </div>
            ))}
          </div>
        )}

        {matchCoaches.length>0 && (
          <div style={{marginBottom:16}}>
            <div style={{fontSize:11,fontWeight:700,color:C.faint,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:10}}>Тренеры ({matchCoaches.length})</div>
            {matchCoaches.map(c=>(
              <div key={c.id} style={{background:"#fff",borderRadius:14,border:`1px solid ${C.border}`,padding:"12px 14px",marginBottom:8,boxShadow:shadow,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{width:36,height:36,borderRadius:"50%",background:C.purpleDim,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:C.purple}}>{c.name[0]}</div>
                  <div>
                    <div style={{fontWeight:700,fontSize:14,color:C.text}}>{c.name}</div>
                    <div style={{fontSize:12,color:C.muted}}>{c.username}</div>
                  </div>
                </div>
                <Tag bg={c.active?C.greenDim:C.redDim} color={c.active?C.green:C.red}>{c.active?"Активен":"Откл."}</Tag>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ── ADMIN VIEWS ────────────────────────────────────────────────────────────────
function AdminOverview({coaches, requests}) {
  const [stats, setStats] = useState(null);
  const [realCoaches, setRealCoaches] = useState([]);

  useEffect(()=>{
    // Загружаем реальную статистику
    fetch('https://mycoachspace.ru/api/admin/stats')
      .then(r=>r.json())
      .then(data=>{ if(data) setStats(data); })
      .catch(()=>{});
    // Загружаем реальных тренеров
    fetch('https://mycoachspace.ru/api/admin/coaches')
      .then(r=>r.json())
      .then(data=>{ if(Array.isArray(data)) setRealCoaches(data); })
      .catch(()=>{});
  },[]);

  const activeCoaches   = stats?.active_coaches   ?? coaches.filter(c=>c.active).length;
  const totalPlayers    = stats?.total_players     ?? coaches.reduce((s,c)=>s+c.players,0);
  const pastSessions    = stats?.past_sessions     ?? coaches.reduce((s,c)=>s+c.sessions,0);
  const futureSessions  = stats?.future_sessions   ?? 0;

  const displayCoaches = realCoaches.length > 0 ? realCoaches : coaches;

  return (
    <div>
      <p style={{color:C.muted,fontSize:13,marginBottom:20}}>Управление платформой</p>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:22}}>
        {[
          {v:activeCoaches, l:"Тренеры",    s:"активных",   c:C.purple},
          {v:totalPlayers,  l:"Участники",  s:"всего",      c:C.accent},
          {v:pastSessions,  l:"Тренировки", s:"проведено",  c:C.green},
          {v:futureSessions,l:"Тренировки", s:"запланировано", c:C.yellow},
        ].map(x=>(
          <Card key={x.l+x.s} sx={{padding:"14px 10px",textAlign:"center"}}>
            <div style={{fontSize:26,fontWeight:800,color:x.c}}>{x.v}</div>
            <div style={{fontSize:11,color:C.muted,marginTop:2}}>{x.l}</div>
            <div style={{fontSize:10,color:C.faint}}>{x.s}</div>
          </Card>
        ))}
      </div>
      <Section title="Тренеры">
        {displayCoaches.map(c=>(
          <Card key={c.id}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <div style={{width:40,height:40,borderRadius:"50%",background:C.purpleDim,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:16,color:C.purple}}>
                  {(c.name||"?")[0].toUpperCase()}
                </div>
                <div>
                  <div style={{fontWeight:700,fontSize:14,color:C.text}}>{c.name}</div>
                  <div style={{fontSize:12,color:C.muted}}>
                    {c.players_count||c.players||0} участников · {c.sessions_count||c.sessions||0} тренировок
                  </div>
                </div>
              </div>
              <Tag bg={C.greenDim} color={C.green}>Активен</Tag>
            </div>
          </Card>
        ))}
      </Section>
    </div>
  );
}

function AdminCoaches({coaches,setCoaches,requests,setRequests}) {
  const [subtab, setSubtab] = useState("active");

  useEffect(()=>{
    // Загружаем реальных тренеров
    fetch('https://mycoachspace.ru/api/admin/coaches')
      .then(r=>r.json())
      .then(data=>{ if(Array.isArray(data)) setCoaches(data); })
      .catch(()=>{});
    // Загружаем заявки
    fetch('https://mycoachspace.ru/api/coach/requests')
      .then(r=>r.json())
      .then(data=>{ if(Array.isArray(data)) setRequests(data); })
      .catch(()=>{});
  },[]);

  const toggle = id => setCoaches(p=>p.map(c=>c.id===id?{...c,active:!c.active}:c));

  const approve = id => {
    fetch(`https://mycoachspace.ru/api/coach/approve/${id}`, {method:'POST'})
      .then(()=>{
        const r = requests.find(x=>x.id===id);
        if(r) setCoaches(prev=>[...prev,{id:Date.now(),name:r.name,username:r.username,players:0,sessions:0,since:"Сейчас",active:true,firstSession:null,trialDays:21}]);
        setRequests(prev=>prev.filter(x=>x.id!==id));
      }).catch(()=>{});
  };

  const reject = id => {
    fetch(`https://mycoachspace.ru/api/coach/reject/${id}`, {method:'POST'})
      .then(()=>setRequests(prev=>prev.filter(x=>x.id!==id)))
      .catch(()=>{});
  };

  const tabs = [
    {id:"active", label:"Активные", count:coaches.length},
    {id:"requests", label:"Новые запросы", count:requests.length},
  ];

  return (
    <div>
      {/* Sub-tabs */}
      <div style={{display:"flex",background:"#fff",borderRadius:12,border:`1px solid ${C.border}`,padding:4,gap:4,marginBottom:16}}>
        {tabs.map(t=>(
          <button key={t.id} onClick={()=>setSubtab(t.id)} style={{flex:1,padding:"8px",borderRadius:9,border:"none",cursor:"pointer",background:subtab===t.id?C.accent:"transparent",color:subtab===t.id?"#fff":C.muted,fontWeight:subtab===t.id?700:400,fontSize:13,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
            {t.label}
            {t.count>0&&<span style={{background:subtab===t.id?"rgba(255,255,255,0.3)":subtab==="active"&&t.id==="requests"?C.redDim:C.accentDim,color:subtab===t.id?"#fff":subtab==="active"&&t.id==="requests"?C.red:C.accent,borderRadius:20,padding:"1px 7px",fontSize:11,fontWeight:700}}>{t.count}</span>}
          </button>
        ))}
      </div>

      {/* Active coaches */}
      {subtab==="active" && (
        <>
          <div style={{fontSize:11,fontWeight:700,color:C.faint,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:12}}>Тренеры ({coaches.length})</div>
          {coaches.map(c=>(
            <Card key={c.id}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  <div style={{width:46,height:46,borderRadius:"50%",background:C.purpleDim,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:18,color:C.purple,flexShrink:0}}>{c.name[0]}</div>
                  <div>
                    <div style={{fontWeight:700,fontSize:15,color:C.text}}>{c.name}</div>
                    <div style={{fontSize:12,color:C.muted}}>{c.username}</div>
                  </div>
                </div>
                <Tag bg={C.greenDim} color={C.green}>● Активен</Tag>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:10}}>
                {[
                  {v:c.players_count||c.players||0,    l:"участников"},
                  {v:c.completed_count||c.sessions||0, l:"состоялось"},
                  {v:c.planned_count||c.planned||0,    l:"запланировано"},
                ].map(x=>(
                  <div key={x.l} style={{background:C.bg,borderRadius:10,padding:"10px 6px",textAlign:"center"}}>
                    <div style={{fontWeight:800,fontSize:14,color:C.text}}>{x.v}</div>
                    <div style={{fontSize:10,color:C.faint,marginTop:2}}>{x.l}</div>
                  </div>
                ))}
              </div>

              {/* First session + trial */}
              {(c.first_session_date||c.firstSession) ? (
                <div style={{background:C.bg,borderRadius:10,padding:"8px 12px",marginBottom:10}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:5}}>
                    <span style={{fontSize:12,color:C.muted}}>📅 Первая тренировка: <strong style={{color:C.text}}>{formatDate(c.first_session_date||c.firstSession)}</strong></span>
                    <span style={{fontSize:12,fontWeight:700,color:trialStatus(c).color}}>{trialStatus(c).label}</span>
                  </div>
                  <div style={{background:C.border,borderRadius:20,height:4,overflow:"hidden"}}>
                    <div style={{height:"100%",borderRadius:20,background:trialStatus(c).color,width:trialStatus(c).pct+"%"}}/>
                  </div>
                </div>
              ) : (
                <div style={{background:C.yellowLight,borderRadius:10,padding:"7px 12px",marginBottom:10,fontSize:12,color:C.yellow}}>
                  ⏳ Тренировок ещё не было — тестовый период не начат
                </div>
              )}

              
            </Card>
          ))}
        </>
      )}

      {/* Pending requests */}
      {subtab==="requests" && (
        <>
          {requests.length===0 ? (
            <div style={{textAlign:"center",padding:"40px 20px",color:C.muted}}>
              <div style={{fontSize:40,marginBottom:12}}>✅</div>
              <div style={{fontWeight:700,fontSize:16,color:C.text,marginBottom:6}}>Новых запросов нет</div>
              <div style={{fontSize:13}}>Все заявки обработаны</div>
            </div>
          ) : requests.map(r=>(
            <Card key={r.id}>
              <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:14}}>
                <div style={{width:46,height:46,borderRadius:"50%",background:C.yellowDim,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:18,color:C.yellow,flexShrink:0}}>{r.name[0]}</div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,fontSize:15,color:C.text}}>{r.name}</div>
                  <div style={{fontSize:12,color:C.muted}}>{r.username} · {r.requestDate}</div>
                </div>
                <Tag bg={C.yellowDim} color={C.yellow}>⏳ Ожидает</Tag>
              </div>
              <div style={{display:"flex",gap:10}}>
                <Btn full variant="danger" onClick={()=>reject(r.id)}>✕  Отклонить</Btn>
                <Btn full variant="success" onClick={()=>approve(r.id)}>✓  Одобрить</Btn>
              </div>
            </Card>
          ))}
        </>
      )}
    </div>
  );
}



// ── LEGAL DOCS MODAL ───────────────────────────────────────────────────────────
const LEGAL_DOCS = {
  terms: {
    title: "Пользовательское соглашение",
    sections: [
      {h:"1. Общие положения", t:"Настоящее Соглашение регулирует использование сервиса CoachSpace, доступного через мессенджер Telegram. Используя Сервис, вы подтверждаете согласие с условиями. Оператором Сервиса является [ИП / ООО], ИНН [ХХХХ]."},
      {h:"2. Описание сервиса", t:"CoachSpace — платформа для организации записи на тренировки, взаимодействия тренеров и участников. Тренерам предоставляются инструменты управления расписанием и учёта платежей. Участникам — возможность записываться на тренировки и получать уведомления."},
      {h:"3. Регистрация и доступ", t:"Доступ к Сервису осуществляется через аккаунт Telegram. Тренер получает доступ после одобрения заявки. Участник — по пригласительной ссылке от тренера. Пользователь несёт ответственность за достоверность указанных данных."},
      {h:"4. Права и обязанности", t:"Оператор обеспечивает работоспособность Сервиса и уведомляет о плановых работах. Оператор вправе ограничить доступ при нарушении Соглашения. Пользователь обязуется не использовать Сервис в противоправных целях. Тренер самостоятельно несёт ответственность за организацию тренировок."},
      {h:"5. Оплата", t:"Использование Сервиса тренером является платным согласно действующему тарифу. Тарифы могут быть изменены с уведомлением за 14 дней. Расчёты между тренером и участниками осуществляются самостоятельно, вне Сервиса."},
      {h:"6. Ограничение ответственности", t:"Оператор не несёт ответственности за качество тренировок и действия тренеров, а также за сбои в работе Telegram. Совокупная ответственность ограничена суммой фактически уплаченного тарифа за последний расчётный период."},
      {h:"7. Прекращение доступа", t:"Пользователь вправе прекратить использование Сервиса в любое время. Оператор вправе заблокировать доступ при нарушении Соглашения."},
      {h:"8. Изменение соглашения", t:"Оператор вправе изменять условия, уведомив пользователей за 7 дней до вступления в силу изменений."},
    ]
  },
  privacy: {
    title: "Политика конфиденциальности",
    sections: [
      {h:"1. Какие данные мы собираем", t:"Имя и фамилия из профиля Telegram, Telegram ID и username, данные введённые вручную (имя в приложении), история записей на тренировки, данные об оплатах (для тренеров)."},
      {h:"2. Как мы используем данные", t:"Для обеспечения работы Сервиса, отправки уведомлений через Telegram, отображения тренеру информации о его участниках, ведения внутренней статистики платформы."},
      {h:"3. Кому мы передаём данные", t:"Мы не продаём данные третьим лицам. Данные участника (имя, уровень) передаются тренеру, который его пригласил. Данные могут быть переданы по требованию уполномоченных органов согласно законодательству РФ."},
      {h:"4. Хранение данных", t:"Данные хранятся на защищённых серверах в течение всего срока использования Сервиса и 1 год после его прекращения."},
      {h:"5. Ваши права", t:"Вы вправе запросить копию своих данных, потребовать исправления или удаления данных (с прекращением доступа к Сервису). Для реализации прав обратитесь: support@coachspace.app"},
      {h:"6. Изменение политики", t:"Об изменениях уведомляем через Сервис за 7 дней до вступления в силу."},
    ]
  },
  consent: {
    title: "Согласие на обработку персональных данных",
    sections: [
      {h:"Текст согласия", t:"Я даю согласие [ИП / ООО], ИНН [ХХХХ], на обработку моих персональных данных (имя, Telegram ID, история активности в Сервисе) в целях обеспечения работы сервиса CoachSpace, включая их хранение и использование для отправки уведомлений через Telegram. Согласие дано на срок использования Сервиса и может быть отозвано путём обращения на support@coachspace.app."},
    ]
  }
};

function LegalModal({doc, onClose}) {
  const d = LEGAL_DOCS[doc];
  if(!d) return null;
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"flex-end",zIndex:600}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:"20px 20px 0 0",width:"100%",maxHeight:"85vh",display:"flex",flexDirection:"column"}}>
        <div style={{padding:"20px 20px 14px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div style={{fontWeight:800,fontSize:16,color:C.text}}>{d.title}</div>
          <button onClick={onClose} style={{background:C.bg,border:"none",borderRadius:"50%",width:32,height:32,cursor:"pointer",fontSize:16,color:C.muted}}>✕</button>
        </div>
        <div style={{overflowY:"auto",padding:"16px 20px 32px"}}>
          <div style={{fontSize:11,color:C.faint,marginBottom:16}}>Редакция от 28 мая 2026 г. · Шаблон, требует юридической проверки</div>
          {d.sections.map((s,i)=>(
            <div key={i} style={{marginBottom:16}}>
              <div style={{fontWeight:700,fontSize:14,color:C.text,marginBottom:6}}>{s.h}</div>
              <div style={{fontSize:13,color:C.muted,lineHeight:1.7}}>{s.t}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── LEGAL CONSENT BLOCK ────────────────────────────────────────────────────────
function LegalConsent({agreed, setAgreed}) {
  const [openDoc, setOpenDoc] = useState(null);
  return (
    <div>
      <div onClick={()=>setAgreed(!agreed)} style={{display:"flex",alignItems:"flex-start",gap:12,cursor:"pointer",background:agreed?C.greenLight:C.bg,border:`1.5px solid ${agreed?C.green+"55":C.border}`,borderRadius:12,padding:"12px 14px",marginBottom:10,transition:"all 0.15s"}}>
        <div style={{width:22,height:22,borderRadius:6,border:`2px solid ${agreed?C.green:C.borderStrong}`,background:agreed?C.green:"#fff",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
          {agreed&&<span style={{color:"#fff",fontSize:13,fontWeight:800}}>✓</span>}
        </div>
        <div style={{fontSize:13,color:C.text,lineHeight:1.6}}>
          Я принимаю{" "}
          <span onClick={e=>{e.stopPropagation();setOpenDoc("terms");}} style={{color:C.accent,textDecoration:"underline",cursor:"pointer"}}>Условия использования</span>
          {" "}и{" "}
          <span onClick={e=>{e.stopPropagation();setOpenDoc("privacy");}} style={{color:C.accent,textDecoration:"underline",cursor:"pointer"}}>Политику конфиденциальности</span>
          , а также даю{" "}
          <span onClick={e=>{e.stopPropagation();setOpenDoc("consent");}} style={{color:C.accent,textDecoration:"underline",cursor:"pointer"}}>согласие на обработку персональных данных</span>
        </div>
      </div>
      {openDoc && <LegalModal doc={openDoc} onClose={()=>setOpenDoc(null)}/>}
    </div>
  );
}

// ── PLAYER NAME FORM ───────────────────────────────────────────────────────────
function PlayerNameForm({defaultName, onSave}) {
  const [name,    setName]    = useState(defaultName);
  const [edited,  setEdited]  = useState(false);
  return (
    <div>
      <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:6}}>Ваше имя</div>
      <input
        value={name}
        onChange={e=>{setName(e.target.value);setEdited(true);}}
        style={{width:"100%",border:`1.5px solid ${edited?C.accent:C.border}`,borderRadius:12,padding:"13px 16px",fontSize:16,color:C.text,background:"#fff",boxSizing:"border-box",outline:"none",marginBottom:6}}
        onFocus={e=>e.target.style.borderColor=C.accent}
        onBlur={e=>e.target.style.borderColor=edited?C.accent:C.border}
      />
      {!edited && <div style={{fontSize:11,color:C.faint,marginBottom:14}}>📱 Имя взято из вашего профиля Telegram. Можете изменить.</div>}
      {edited  && <div style={{fontSize:11,color:C.accent,marginBottom:14}}>✓ Будет отображаться именно это имя</div>}
      <Btn full onClick={()=>name.trim()&&onSave(name.trim())} disabled={!name.trim()}>
        Продолжить
      </Btn>
    </div>
  );
}

// ── ROOT ───────────────────────────────────────────────────────────────────────
export default function App() {
  const [role,setRole]           = useState(null);
  const [tab,setTab]             = useState("home");
  const [token,setToken]         = useState(null);
  const [loading,setLoading]     = useState(true);
  const [userName,setUserName]   = useState(null);

  // Авторизация через Telegram при старте
  useEffect(()=>{
    const tg = window.Telegram?.WebApp;
    if(tg && tg.initDataUnsafe?.user) {
      const user = tg.initDataUnsafe.user;
      const ADMIN_ID = 273972439;

      if(user.id === ADMIN_ID) {
        setRole("admin");
        setTab("overview");
        setLoading(false);
        return;
      }

      // Проверяем пригласительный код из URL (?ref=coach_xxx)
      const urlParams = new URLSearchParams(window.location.search);
      const refCode = urlParams.get('ref');

      if(refCode && refCode.startsWith('coach_')) {
        // Автоматически входим по инвайт-коду
        fetch('https://mycoachspace.ru/api/coach/join', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({
            invite_code: refCode,
            telegram_id: user.id,
            name: user.first_name + (user.last_name?' '+user.last_name:''),
            username: user.username||'',
          })
        })
        .then(r=>r.json())
        .then(data=>{
          if(data.token) {
            setToken(data.token);
            setRole('player');
            setTab('bookings');
          }
          setLoading(false);
        })
        .catch(()=>setLoading(false));
        return;
      }

      if(user.id === ADMIN_ID) {
        setRole("admin");
        setTab("overview");
        setLoading(false);
        return;
      }

      // Проверяем есть ли пользователь в базе
      fetch('https://mycoachspace.ru/api/auth/check', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          telegram_id: user.id,
          name: user.first_name + (user.last_name?' '+user.last_name:''),
          username: user.username||'',
        })
      })
      .then(r=>r.json())
      .then(data=>{
        if(data.token && data.user) {
          setToken(data.token);
          setRole(data.user.role);
          setUserName(data.user.name||null);
          setTab(data.user.role==='coach'?'home':'bookings');
          // Для участника сразу подставляем имя из БД
          if(data.user.role==='player') {
            setPlayerName(data.user.name||null);
          }
          // Обновляем username если изменился
          if(data.user.username !== user.username && user.username) {
            fetch('https://mycoachspace.ru/api/auth/update', {
              method:'POST',
              headers:{'Content-Type':'application/json','Authorization':'Bearer '+data.token},
              body: JSON.stringify({username: user.username})
            }).catch(()=>{});
          }
        }
        // Если не найден — role остаётся null, показываем экран выбора
        setLoading(false);
      })
      .catch(()=>setLoading(false));
    } else {
      setLoading(false);
    }
  },[]);

  const [modal,setModal]         = useState(false);
  const [sharedEdit,setSharedEdit]   = useState(null);
  const [sharedPay,setSharedPay]     = useState(null);
  const [sharedManual,setSharedManual] = useState(null);
  const [coaches,setCoaches]     = useState(INIT_COACHES);
  const [requests,setRequests]   = useState(INIT_REQUESTS);
  const [showBroadcast,setShowBroadcast] = useState(false);
  const [trialDays,setTrialDays] = useState(21);
  const [showSearch,setShowSearch]   = useState(false);
  const [playerName,setPlayerName]   = useState(null);
  const [playerLevel,setPlayerLevel] = useState(null);
  const [codeInput, setCodeInput]    = useState('');
  const [codeError, setCodeError]    = useState(null);
  const [codeLoading, setCodeLoading] = useState(false);
  const [locations,setLocations] = useState(INIT_LOCATIONS);
  const [players,setPlayers]     = useState(INIT_PLAYERS);
  const [sessions,setSessions]   = useState(INIT_SESSIONS);
  const [bookings,setBookings]   = useState([1,4]);
  const [myBookings,setMyBookings] = useState([]);
  const [levels,setLevels]       = useState(["Начинающий","Средний","Продвинутый"]);
  const [editName,setEditName]   = useState("");

  const API = 'https://mycoachspace.ru/api';

  // Загрузка данных из API после авторизации
  useEffect(()=>{
    if(!token || !role) return;
    const h = {'Authorization':'Bearer '+token,'Content-Type':'application/json'};

    if(role==='coach') {
      // Загружаем тренировки
      fetch(API+'/sessions',{headers:h}).then(r=>r.json()).then(data=>{
        if(Array.isArray(data)) setSessions(data);
      }).catch(()=>{});
      // Загружаем локации
      fetch(API+'/locations',{headers:h}).then(r=>r.json()).then(data=>{
        if(Array.isArray(data)) setLocations(data);
      }).catch(()=>{});
      // Загружаем участников
      fetch(API+'/players',{headers:h}).then(r=>r.json()).then(data=>{
        if(Array.isArray(data)) setPlayers(data);
      }).catch(()=>{});
    }

    if(role==='player') {
      // Загружаем доступные тренировки
      fetch(API+'/sessions/available',{headers:h}).then(r=>r.json()).then(data=>{
        if(Array.isArray(data)) setSessions(data);
      }).catch(()=>{});
      // Загружаем записи участника (полные данные)
      fetch(API+'/bookings/my',{headers:h}).then(r=>r.json()).then(data=>{
        if(Array.isArray(data)) {
          setBookings(data.map(b=>b.session_id));
          setMyBookings(data); // сохраняем полные данные
        }
      }).catch(()=>{});
      // Загружаем уровень участника
      fetch(API+'/players/me',{headers:h}).then(r=>r.json()).then(data=>{
        if(data.level) setPlayerLevel(data.level);
      }).catch(()=>{});
    }
  },[token,role]);

  const alexei  = coaches.find(c=>c.id===1);
  const blocked = alexei&&!alexei.active;

  const base={fontFamily:"'Inter','Segoe UI',system-ui,sans-serif",background:C.bg,minHeight:"100vh",color:C.text};

  // Экран загрузки
  if(loading) return (
    <div style={{...base,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",minHeight:"100vh",padding:20}}>
      <div style={{fontSize:48,marginBottom:16}}>🏅</div>
      <div style={{fontWeight:700,fontSize:16,color:C.text}}>CoachSpace</div>
      <div style={{fontSize:13,color:C.muted,marginTop:8}}>Загрузка...</div>
    </div>
  );

  // ── Player onboarding (first entry) ──
  if(role==="player" && playerName===null) return (
    <div style={{...base,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:32}}>
      <div style={{fontSize:52,marginBottom:14}}>👋</div>
      <div style={{fontWeight:800,fontSize:22,color:C.text,marginBottom:6,textAlign:"center"}}>Добро пожаловать!</div>
      <div style={{color:C.muted,fontSize:14,marginBottom:28,textAlign:"center",lineHeight:1.6}}>
        Как вас будет видеть тренер?<br/>
        <span style={{fontSize:12,color:C.faint}}>По умолчанию используется имя из Telegram</span>
      </div>
      <div style={{width:"100%",maxWidth:340}}>
        <PlayerNameForm
          defaultName={window.Telegram?.WebApp?.initDataUnsafe?.user ? 
            (window.Telegram.WebApp.initDataUnsafe.user.first_name + 
            (window.Telegram.WebApp.initDataUnsafe.user.last_name ? ' ' + window.Telegram.WebApp.initDataUnsafe.user.last_name : '')) 
            : "Ваше имя"}
          onSave={name=>{
            setPlayerName(name);
            setTab("bookings");
            // Сохраняем имя в БД
            if(token) fetch(API+'/auth/update-name', {
              method:'POST',
              headers:{'Authorization':'Bearer '+token,'Content-Type':'application/json'},
              body: JSON.stringify({name})
            }).catch(()=>{});
          }}
        />
        <button onClick={()=>setRole(null)} style={{background:"none",border:"none",color:C.muted,fontSize:13,cursor:"pointer",marginTop:12,width:"100%"}}>← Назад</button>
      </div>
    </div>
  );

  // ── No-invite screen ──
  const joinByCode = async () => {
    if (!codeInput.trim()) return;
    setCodeLoading(true); setCodeError(null);
    const tgUser = window.Telegram?.WebApp?.initDataUnsafe?.user;
    try {
      const r = await fetch(API+'/coach/join', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          invite_code: codeInput.trim(),
          telegram_id: tgUser?.id,
          name: tgUser ? (tgUser.first_name+(tgUser.last_name?' '+tgUser.last_name:'')) : 'Участник',
          username: tgUser?.username||'',
        })
      });
      const data = await r.json();
      if (!r.ok) { setCodeError(data.error||'Неверный код'); setCodeLoading(false); return; }
      setToken(data.token);
      setRole('player');
      setTab('bookings');
    } catch(e) { setCodeError('Ошибка соединения'); }
    setCodeLoading(false);
  };

  if(role==="nocode") return (
    <div style={{...base,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:32,textAlign:"center"}}>
      <div style={{fontSize:52,marginBottom:16}}>🔗</div>
      <div style={{fontWeight:800,fontSize:22,color:C.text,marginBottom:8}}>Нужна ссылка от тренера</div>
      <div style={{color:C.muted,fontSize:14,marginBottom:28,lineHeight:1.7,maxWidth:320}}>
        Чтобы попасть в приложение, вам нужна персональная пригласительная ссылка от тренера.<br/><br/>
        Попросите тренера отправить вам ссылку — после перехода по ней вы автоматически увидите его расписание.
      </div>
      <div style={{background:C.accentLight,border:`1px solid ${C.accent}33`,borderRadius:14,padding:"14px 18px",marginBottom:28,width:"100%",maxWidth:320}}>
        <div style={{fontSize:12,color:C.accent,fontWeight:600,marginBottom:6}}>Как это работает:</div>
        <div style={{fontSize:13,color:C.muted,lineHeight:1.7,textAlign:"left"}}>
          1. Тренер копирует свою ссылку в разделе «Настройки»<br/>
          2. Отправляет её вам в Telegram<br/>
          3. Вы переходите по ссылке — и сразу видите расписание
        </div>
      </div>
      <div style={{width:"100%",maxWidth:320,display:"flex",flexDirection:"column",gap:10}}>
        <div style={{fontSize:12,color:C.muted,marginBottom:4}}>Или введите код вручную:</div>
        {codeError&&<div style={{background:"#fee2e2",borderRadius:10,padding:"8px 12px",fontSize:13,color:"#dc2626"}}>{codeError}</div>}
        <div style={{display:"flex",gap:8}}>
          <input value={codeInput} onChange={e=>setCodeInput(e.target.value)} placeholder="coach_name_abc123"
            style={{flex:1,border:`1.5px solid ${C.border}`,borderRadius:10,padding:"10px 14px",fontSize:13,color:C.text,background:"#fff",outline:"none"}}/>
          <Btn onClick={joinByCode} disabled={codeLoading}>{codeLoading?"...":"Войти"}</Btn>
        </div>
        <button onClick={()=>setRole(null)} style={{background:"none",border:"none",color:C.muted,fontSize:13,cursor:"pointer",marginTop:4}}>← Назад</button>
      </div>
    </div>
  );

  // ── Coach registration screen ──
  if(role==="newcoach") {
    const tgUser = window.Telegram?.WebApp?.initDataUnsafe?.user;
    const tgName = tgUser ? (tgUser.first_name + (tgUser.last_name?' '+tgUser.last_name:'')) : '';
    const tgUsername = tgUser?.username || '';
    const tgId = tgUser?.id;
    const displayName = editName || tgName;

    const submitApplication = () => {
      fetch('https://mycoachspace.ru/api/coach/apply', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ telegram_id: tgId, name: displayName||tgName, username: tgUsername })
      })
      .then(r=>r.json())
      .then(()=>setRole("applied"))
      .catch(()=>setRole("applied"));
    };

    return (
      <div style={{...base,overflowY:"auto"}}>
        <div style={{padding:"20px 20px 0",display:"flex",alignItems:"center",gap:12}}>
          <button onClick={()=>setRole(null)} style={{background:"none",border:"none",color:C.accent,fontSize:14,fontWeight:600,cursor:"pointer",padding:0}}>← Назад</button>
        </div>
        <div style={{padding:"20px 20px 90px"}}>
          <div style={{width:56,height:56,background:C.accentLight,borderRadius:16,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,marginBottom:14}}>👨‍🏫</div>
          <div style={{fontWeight:800,fontSize:22,color:C.text,marginBottom:4}}>Регистрация тренера</div>
          <div style={{color:C.muted,fontSize:14,marginBottom:24,lineHeight:1.5}}>После отправки администратор рассмотрит вашу заявку.</div>

          <div style={{marginBottom:14}}>
            <div style={{fontSize:12,fontWeight:600,color:C.muted,marginBottom:6}}>Ваше имя</div>
            <input value={editName||tgName} onChange={e=>setEditName(e.target.value)}
              style={{width:"100%",border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 16px",fontSize:15,color:C.text,background:"#fff",boxSizing:"border-box",outline:"none"}}
              onFocus={e=>e.target.style.borderColor=C.accent}
              onBlur={e=>e.target.style.borderColor=C.border}
            />
            <div style={{fontSize:11,color:C.faint,marginTop:4}}>📱 Подставлено из Telegram — можете изменить</div>
          </div>

          <div style={{background:C.bg,borderRadius:12,padding:"12px 16px",marginBottom:16}}>
            <div style={{fontSize:12,color:C.faint,marginBottom:2}}>Telegram username</div>
            <div style={{fontSize:14,color:C.text,fontWeight:600}}>@{tgUsername||"не указан"}</div>
          </div>

          <div style={{background:C.yellowLight,border:`1px solid ${C.yellow}44`,borderRadius:12,padding:"12px 14px",marginBottom:20,fontSize:13,color:C.yellow}}>
            ⏳ После одобрения заявки Вы получите уведомление в Telegram
          </div>
          <Btn full onClick={submitApplication} disabled={!(editName||tgName).trim()}>Отправить заявку</Btn>
        </div>
      </div>
    );
  }

  if(role==="pending") return (
    <div style={{...base,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:32,textAlign:"center"}}>
      <div style={{fontSize:52,marginBottom:16}}>⏳</div>
      <div style={{fontWeight:800,fontSize:22,color:C.text,marginBottom:8}}>Заявка на рассмотрении</div>
      <div style={{color:C.muted,fontSize:14,lineHeight:1.7,maxWidth:320}}>
        Администратор рассматривает вашу заявку. Вы получите уведомление в Telegram.
      </div>
    </div>
  );

  if(role==="applied") return (
    <div style={{...base,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:32,textAlign:"center"}}>
      <div style={{fontSize:52,marginBottom:16}}>✅</div>
      <div style={{fontWeight:800,fontSize:22,color:C.text,marginBottom:8}}>Заявка отправлена!</div>
      <div style={{color:C.muted,fontSize:14,lineHeight:1.7,maxWidth:320}}>
        Администратор рассмотрит вашу заявку и вы получите уведомление в Telegram.
      </div>
    </div>
  );

  if(!role) return (
    <div style={{...base,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:32}}>
      <div style={{width:68,height:68,background:C.accentLight,borderRadius:20,display:"flex",alignItems:"center",justifyContent:"center",fontSize:36,marginBottom:16,boxShadow:"0 4px 16px rgba(37,99,235,0.15)"}}>🏅</div>
      <div style={{fontWeight:800,fontSize:26,color:C.text,marginBottom:4}}>CoachSpace</div>
      <div style={{color:C.muted,fontSize:14,marginBottom:40}}>Запись на тренировки</div>
      <div style={{width:"100%",maxWidth:340,display:"flex",flexDirection:"column",gap:12}}>
        <button onClick={()=>setRole("newcoach")}
          style={{background:C.accent,color:"#fff",border:"none",borderRadius:14,padding:"16px",fontWeight:700,fontSize:16,cursor:"pointer",boxShadow:shadow}}>
          👨‍🏫  Я тренер — подать заявку
        </button>
        <button onClick={()=>setRole("nocode")}
          style={{background:"#fff",color:C.text,border:`1.5px solid ${C.border}`,borderRadius:14,padding:"16px",fontWeight:700,fontSize:16,cursor:"pointer",boxShadow:shadow}}>
          🔗  У меня есть код от тренера
        </button>
      </div>
    </div>
  );

  const navMap = {
    admin:  [{id:"overview",icon:"◉",label:"Обзор"},{id:"coaches",icon:"👨‍🏫",label:"Тренеры"},{id:"payments",icon:"💰",label:"Оплаты"},{id:"asettings",icon:"⚙️",label:"Настройки"}],
    coach:  [{id:"home",icon:"◉",label:"Главная"},{id:"sessions",icon:"📅",label:"Расписание"},{id:"players",icon:"👥",label:"Участники"},{id:"settings",icon:"⚙️",label:"Настройки"}],
    player: [{id:"bookings",icon:"✓",label:"Мои записи"},{id:"calendar",icon:"📅",label:"Открытые тренировки"},{id:"notifications",icon:"🔔",label:"Уведомления"}],
  };
  const nav=navMap[role];
  const accentColor=role==="admin"?C.purple:C.accent;

  const titleMap={overview:"Обзор",coaches:"Тренеры",payments:"Оплаты",broadcast:"Рассылка",asettings:"Настройки",users:"Пользователи",home:"Главная",sessions:"Расписание",players:"Участники",settings:"Настройки",bookings:"Мои записи",calendar:"Открытые тренировки",notifications:"Уведомления"};
  const subMap={admin:"👑 Администратор",coach:blocked?"⛔ Доступ ограничен":"👨‍🏫 "+(userName||"Тренер"),player:"🏅 " + (playerName||"Участник") + (playerLevel?" · "+playerLevel:"")};

  let content;
  if(role==="admin"){
    if(tab==="overview") content=<AdminOverview coaches={coaches} requests={requests}/>;
    else if(tab==="coaches") content=<AdminCoaches coaches={coaches} setCoaches={setCoaches} requests={requests} setRequests={setRequests}/>;
    else if(tab==="payments") content=<AdminPayments coaches={coaches}/>;
    else if(tab==="asettings") content=<AdminSettings trialDays={trialDays} setTrialDays={setTrialDays} coaches={coaches} players={players} onBroadcast={()=>setShowBroadcast(true)}/>;
    else content=<AdminUsers coaches={coaches} players={players}/>;
  } else if(role==="coach"){
    if(blocked) content=<div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"60px 20px",textAlign:"center"}}><div style={{fontSize:52,marginBottom:16}}>🚫</div><div style={{fontWeight:800,fontSize:20,color:C.text,marginBottom:8}}>Доступ ограничен</div><div style={{color:C.muted,fontSize:14,lineHeight:1.7}}>Администратор приостановил вашу возможность создавать тренировки. Свяжитесь с администратором.</div></div>;
    else if(tab==="home") content=<CoachHome sessions={sessions} locations={locations} onAdd={()=>setModal(true)} players={players} setPlayers={setPlayers} onEditSession={s=>setSharedEdit(s)} onPaySession={s=>setSharedPay(s)} onManualSession={s=>setSharedManual(s)} token={token} API={API}/>;
    else if(tab==="sessions") content=<CoachSessions sessions={sessions} locations={locations} onAdd={()=>setModal(true)} players={players} token={token} API={API} setSessions={setSessions}/>;
    else if(tab==="players") content=<CoachPlayers players={players} setPlayers={setPlayers} levels={levels} token={token} API={API}/>;
    else content=<CoachSettings locations={locations} setLocations={setLocations} players={players} setPlayers={setPlayers} levels={levels} setLevels={setLevels} token={token} API={API}/>;
  } else {
    if(tab==="bookings") content=<PlayerBookings sessions={sessions} locations={locations} bookings={bookings} setBookings={setBookings} myBookings={myBookings} setMyBookings={setMyBookings} token={token} API={API}/>;
    else if(tab==="calendar") content=<PlayerCalendar sessions={sessions} locations={locations} bookings={bookings} setBookings={setBookings} token={token} API={API}/>;
    else content=<PlayerNotifications/>;
  }

  return (
    <div style={base}>
      <div style={{padding:"20px 20px 0",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <div style={{fontWeight:800,fontSize:20,color:C.text}}>{titleMap[tab]}</div>
          <div style={{fontSize:12,color:role==="coach"&&blocked?C.red:C.muted,marginTop:2}}>{subMap[role]}</div>
        </div>
        <div style={{display:"flex",gap:8}}>

          {!window.Telegram?.WebApp?.initDataUnsafe?.user && (
            <button onClick={()=>{setRole(null);setTab("home");setPlayerName(null);}} style={{background:"#fff",border:`1px solid ${C.border}`,color:C.muted,borderRadius:20,padding:"6px 14px",fontSize:12,cursor:"pointer",boxShadow:shadow}}>
              Сменить роль
            </button>
          )}
        </div>
      </div>

      <div style={{padding:"16px 20px 90px"}}>{content}</div>

      <div style={{position:"fixed",bottom:0,left:0,right:0,background:"#fff",borderTop:`1px solid ${C.border}`,display:"flex",padding:"10px 0 16px",boxShadow:"0 -2px 12px rgba(0,0,0,0.06)"}}>
        {nav.map(n=>(
          <button key={n.id} onClick={()=>setTab(n.id)} style={{flex:1,background:"none",border:"none",cursor:"pointer",color:tab===n.id?accentColor:C.faint,display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
            <span style={{fontSize:19}}>{n.icon}</span>
            <span style={{fontSize:10,fontWeight:tab===n.id?700:400}}>{n.label}</span>
          </button>
        ))}
      </div>

      {modal&&<SessionFormModal onClose={()=>setModal(false)} onSave={(result)=>{
        if(result && result.sessions) {
          setSessions(prev=>[...prev,...result.sessions]);
        } else if(result) {
          setSessions(prev=>[...prev,result]);
        }
        setModal(false);
      }} locations={locations} levels={levels} formPlayers={players} token={token} API={API}/>}
      {sharedEdit&&<SessionFormModal session={sharedEdit} onClose={()=>setSharedEdit(null)} onSave={(updated)=>{setSessions(prev=>prev.map(s=>s.id===updated.id?updated:s));setSharedEdit(null);}} locations={locations} levels={levels} formPlayers={players} token={token} API={API}/>}
      {sharedPay&&<PaymentModal session={sharedPay} players={players} onClose={()=>setSharedPay(null)}/>}
      {sharedManual&&<ManualAddModal session={sharedManual} allPlayers={players} onClose={()=>setSharedManual(null)} notifyOnSave={true} onSaved={(n,msg)=>msg&&console.log(msg)} token={token} API={API}/>}
      {showSearch&&<SearchOverlay coaches={coaches} players={players} sessions={sessions} locations={locations} role={role} onClose={()=>setShowSearch(false)}/>}
    </div>
  );
}
